import React, { Component } from 'react'
import clsx from 'clsx';
import { withStyles } from "@material-ui/core/styles"
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import app from './firebase'
import firebase from "firebase/app";
import "firebase/database"
// import { Container } from 'react-bootstrap'
import { Card } from 'react-bootstrap'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import ChamberClass from './ChamberClass'
import GaugeChart from 'react-gauge-chart'
import RadialGauge from 'react-canvas-gauges'
import Chart from './Graph';
import ECG from './ECG';
import Paper from '@material-ui/core/Paper';
import '../App.css';
import { AiFillPrinter } from 'react-icons/ai';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import { useTheme } from '@material-ui/core/styles';
import { LabelImportant } from '@material-ui/icons';
import _ from 'lodash';
import CanvasJSReact from "./canvasjs.react";
import defaultProfile from '../assets/defaultProfile.jpg'

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

function createData(label, y) {
  return { label, y };
}


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },


  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(3),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },

}));

// -------Arrays----------

const mq2Array1 = []
const mq9Array1 = []
const mq135Array1 = []
const roomTempArray1 = []
const humidArray1 = []
const heartRateArray1 = []
const heartRateH1R1_1 = []
const heartRateH1R2_1 = []
const heartRateH1R3_1 = []
const heartRateH1R4_1 = []
const heartRateH2R1_1 = []
const heartRateH2R2_1 = []
const bodyTempArray1 = []
const bodyTempHxRy_1 = []
const bodyTempH1R1_1 = []
const bodyTempH1R2_1 = []
const bodyTempH1R3_1 = []
const bodyTempH1R4_1 = []
const bodyTempH2R1_1 = []
const bodyTempH2R2_1 = []
const systolicArray1 = []
const systolicArray2 = []
const systolicH1R1_1 = []
const systolicH1R2_1 = []
const systolicH1R3_1 = []
const systolicH1R4_1 = []
const systolicH2R1_1 = []
const systolicH2R2_1 = []
const diastolicArray1 = []
const diastolicH1R1_1 = []
const diastolicH1R2_1 = []
const diastolicH1R3_1 = []
const diastolicH1R4_1 = []
const diastolicH2R1_1 = []
const diastolicH2R2_1 = []
const bloodOxArray1 = []
const bloodOxH1R1_1 = []
const bloodOxH1R2_1 = []
const bloodOxH1R3_1 = []
const bloodOxH1R4_1 = []
const bloodOxH2R1_1 = []
const bloodOxH2R2_1 = []


// ----------Heart Rate Array--------------------
const heartRateArray = [
  { time: 1, y: 0 },
  { time: 2, y: 0 },
  { time: 3, y: 0 },
  { time: 4, y: 0 },
  { time: 5, y: 0 },
  { time: 6, y: 0 },
  { time: 7, y: 121 },
  { time: 8, y: 116 },
  { time: 9, y: 114 },
  { time: 10, y: 115 },
  { time: 11, y: 111 },
  { time: 12, y: 109 },
  { time: 13, y: 108 },
  { time: 14, y: 109 },
  { time: 15, y: 108 },
  { time: 16, y: 106 },
  { time: 17, y: 105 },
  { time: 18, y: 93 },
  { time: 19, y: 83 },
  { time: 20, y: 0 },
  { time: 21, y: 0 },
  { time: 22, y: 0 },
  { time: 23, y: 0 },
  { time: 24, y: 0 },
  { time: 25, y: 75 },
  { time: 26, y: 73 },
  { time: 27, y: 73 },
  { time: 28, y: 73 },
  { time: 29, y: 75 },
  { time: 30, y: 78 },
  { time: 31, y: 82 },
  { time: 32, y: 86 },
  { time: 33, y: 86 },
  { time: 34, y: 85 },
  { time: 35, y: 83 },
  { time: 36, y: 77 },
  { time: 37, y: 75 },
  { time: 38, y: 74 },
  { time: 39, y: 0 },
  { time: 40, y: 0 },
  { time: 41, y: 0 },
  { time: 42, y: 0 },
  { time: 43, y: 0 },
  { time: 44, y: 0 },
  { time: 45, y: 101 },
  { time: 46, y: 103 },
  { time: 47, y: 103 },
  { time: 48, y: 101 },
  { time: 49, y: 97 },
  { time: 50, y: 89 },
  { time: 51, y: 85 },
  { time: 52, y: 84 },
  { time: 53, y: 83 },
  { time: 54, y: 84 },
  { time: 55, y: 89 },
  { time: 56, y: 87 },
  { time: 57, y: 84 },
  { time: 58, y: 0 },
  { time: 59, y: 0 },
  { time: 60, y: 0 },
  { time: 61, y: 0 },
  { time: 62, y: 0 },
  { time: 63, y: 0 },
  { time: 64, y: 81 },
  { time: 65, y: 79 },
  { time: 66, y: 79 },
  { time: 67, y: 79 },
  { time: 68, y: 78 },
  { time: 69, y: 79 },
  { time: 70, y: 81 },
  { time: 71, y: 81 },
  { time: 72, y: 78 },
  { time: 73, y: 81 },
  { time: 74, y: 82 },
  { time: 75, y: 81 },
  { time: 76, y: 81 },
  { time: 77, y: 0 },
  { time: 78, y: 0 },
  { time: 79, y: 0 },
  { time: 80, y: 0 },
  { time: 81, y: 0 },
  { time: 82, y: 0 },
  { time: 83, y: 68 },
  { time: 84, y: 70 },
  { time: 85, y: 71 },
  { time: 86, y: 74 },
  { time: 87, y: 75 },
  { time: 88, y: 76 },
  { time: 89, y: 76 },
  { time: 90, y: 75 },
  { time: 91, y: 73 },
  { time: 92, y: 73 },
  { time: 93, y: 72 },
  { time: 94, y: 72 },
  { time: 95, y: 72 },
  { time: 96, y: 0 },
  { time: 97, y: 0 },
  { time: 98, y: 0 },
  { time: 99, y: 0 },
  { time: 100, y: 0 }
]


// ----------MQ2  Array--------------------
const mq2Array = [
  { time: 1, y: 63 },
  { time: 2, y: 63 },
  { time: 3, y: 62 },
  { time: 4, y: 62 },
  { time: 5, y: 62 },
  { time: 6, y: 62 },
  { time: 7, y: 62 },
  { time: 8, y: 61 },
  { time: 9, y: 61 },
  { time: 10, y: 64 },
  { time: 11, y: 64 },
  { time: 12, y: 64 },
  { time: 13, y: 64 },
  { time: 14, y: 63 },
  { time: 15, y: 63 },
  { time: 16, y: 62 },
  { time: 17, y: 62 },
  { time: 18, y: 61 },
  { time: 19, y: 61 },
  { time: 20, y: 60 },
  { time: 21, y: 60 },
  { time: 22, y: 60 },
  { time: 23, y: 58 },
  { time: 24, y: 58 },
  { time: 25, y: 57 },
  { time: 26, y: 57 },
  { time: 27, y: 56 },
  { time: 28, y: 56 },
  { time: 29, y: 59 },
  { time: 30, y: 59 },
  { time: 31, y: 60 },
  { time: 32, y: 60 },
  { time: 33, y: 59 },
  { time: 34, y: 59 },
  { time: 35, y: 56 },
  { time: 36, y: 56 },
  { time: 37, y: 52 },
  { time: 38, y: 52 },
  { time: 39, y: 48 },
  { time: 40, y: 48 },
  { time: 41, y: 46 },
  { time: 42, y: 46 },
  { time: 43, y: 44 },
  { time: 44, y: 44 },
  { time: 45, y: 42 },
  { time: 46, y: 42 },
  { time: 47, y: 40 },
  { time: 48, y: 40 },
  { time: 49, y: 39 },
  { time: 50, y: 39 },
  { time: 51, y: 38 },
  { time: 52, y: 38 },
  { time: 53, y: 37 },
  { time: 54, y: 37 },
  { time: 55, y: 36 },
  { time: 56, y: 36 },
  { time: 57, y: 38 },
  { time: 58, y: 38 },
  { time: 59, y: 39 },
  { time: 60, y: 39 },
  { time: 61, y: 38 },
  { time: 62, y: 38 },
  { time: 63, y: 48 },
  { time: 64, y: 48 },
  { time: 65, y: 47 },
  { time: 66, y: 47 },
  { time: 67, y: 46 },
  { time: 68, y: 46 },
  { time: 69, y: 46 },
  { time: 70, y: 46 },
  { time: 71, y: 46 },
  { time: 72, y: 46 },
  { time: 73, y: 47 },
  { time: 74, y: 47 },
  { time: 75, y: 47 },
  { time: 76, y: 47 },
  { time: 77, y: 48 },
  { time: 78, y: 48 },
  { time: 79, y: 48 },
  { time: 80, y: 49 },
  { time: 81, y: 49 },
  { time: 82, y: 50 },
  { time: 83, y: 50 },
  { time: 84, y: 49 },
  { time: 85, y: 49 },
  { time: 86, y: 48 },
  { time: 87, y: 48 },
  { time: 88, y: 48 },
  { time: 89, y: 48 },
  { time: 90, y: 48 },
  { time: 91, y: 48 },
  { time: 92, y: 48 },
  { time: 93, y: 48 },
  { time: 94, y: 49 },
  { time: 95, y: 49 },
  { time: 96, y: 50 },
  { time: 97, y: 50 },
  { time: 98, y: 52 },
  { time: 99, y: 52 },
  { time: 100, y: 52 }
]

// ----------MQ9 Array--------------------
const mq9Array = [
  { time: 1, y: 90.599998474 },
  { time: 2, y: 90.199996948 },
  { time: 3, y: 89.800003052 },
  { time: 4, y: 89.800003052 },
  { time: 5, y: 89.5 },
  { time: 6, y: 89.5 },
  { time: 7, y: 89.300003052 },
  { time: 8, y: 89.300003052 },
  { time: 9, y: 88.099998474 },
  { time: 10, y: 88.099998474 },
  { time: 11, y: 91.300003052 },
  { time: 12, y: 91.300003052 },
  { time: 13, y: 91.300003052 },
  { time: 14, y: 91.300003052 },
  { time: 15, y: 90.300003052 },
  { time: 16, y: 90.300003052 },
  { time: 17, y: 89.300003052 },
  { time: 18, y: 89.300003052 },
  { time: 19, y: 88.400001526 },
  { time: 20, y: 88.400001526 },
  { time: 21, y: 87.800003052 },
  { time: 22, y: 87.199996948 },
  { time: 23, y: 87.199996948 },
  { time: 24, y: 85.400001526 },
  { time: 25, y: 85.400001526 },
  { time: 26, y: 84 },
  { time: 27, y: 84 },
  { time: 28, y: 83.5 },
  { time: 29, y: 83.5 },
  { time: 30, y: 86.199996948 },
  { time: 31, y: 86.199996948 },
  { time: 32, y: 87.599998474 },
  { time: 33, y: 87.599998474 },
  { time: 34, y: 86.900001526 },
  { time: 35, y: 86.900001526 },
  { time: 36, y: 83.900001526 },
  { time: 37, y: 83.900001526 },
  { time: 38, y: 79.5 },
  { time: 39, y: 79.5 },
  { time: 40, y: 75.799999237 },
  { time: 41, y: 75.799999237 },
  { time: 42, y: 73 },
  { time: 43, y: 73 },
  { time: 44, y: 71.400001526 },
  { time: 45, y: 71.400001526 },
  { time: 46, y: 69.799999237 },
  { time: 47, y: 69.799999237 },
  { time: 48, y: 67.799999237 },
  { time: 49, y: 67.799999237 },
  { time: 50, y: 66.400001526 },
  { time: 51, y: 66.400001526 },
  { time: 52, y: 65 },
  { time: 53, y: 65 },
  { time: 54, y: 64.200000763 },
  { time: 55, y: 64.200000763 },
  { time: 56, y: 63.599998474 },
  { time: 57, y: 63.599998474 },
  { time: 58, y: 65.5 },
  { time: 59, y: 65.5 },
  { time: 60, y: 66.099998474 },
  { time: 61, y: 66.099998474 },
  { time: 62, y: 65.900001526 },
  { time: 63, y: 65.900001526 },
  { time: 64, y: 75.099998474 },
  { time: 65, y: 75.099998474 },
  { time: 66, y: 74.599998474 },
  { time: 67, y: 74.599998474 },
  { time: 68, y: 73.400001526 },
  { time: 69, y: 73.400001526 },
  { time: 70, y: 73.299999237 },
  { time: 71, y: 73.299999237 },
  { time: 72, y: 73.700000763 },
  { time: 73, y: 73.700000763 },
  { time: 74, y: 74.099998474 },
  { time: 75, y: 74.099998474 },
  { time: 76, y: 74.700000763 },
  { time: 77, y: 74.700000763 },
  { time: 78, y: 75.299999237 },
  { time: 79, y: 75.299999237 },
  { time: 80, y: 75.700000763 },
  { time: 81, y: 75.700000763 },
  { time: 82, y: 76.599998474 },
  { time: 83, y: 76.599998474 },
  { time: 84, y: 77 },
  { time: 85, y: 77 },
  { time: 86, y: 76.099998474 },
  { time: 87, y: 76.099998474 },
  { time: 88, y: 75.599998474 },
  { time: 89, y: 75.599998474 },
  { time: 90, y: 75.5 },
  { time: 91, y: 75.5 },
  { time: 92, y: 75.599998474 },
  { time: 93, y: 75.599998474 },
  { time: 94, y: 75.799999237 },
  { time: 95, y: 75.799999237 },
  { time: 96, y: 76 },
  { time: 97, y: 76 },
  { time: 98, y: 77.400001526 },
  { time: 99, y: 77.400001526 },
  { time: 100, y: 79.599998474 }
]

// ----------MQ135  Array--------------------
const mq135Array = [
  { time: 1, y: 116.599998474 },
  { time: 2, y: 116.199996948 },
  { time: 3, y: 115.800003052 },
  { time: 4, y: 115.800003052 },
  { time: 5, y: 115.5 },
  { time: 6, y: 115.5 },
  { time: 7, y: 115.300003052 },
  { time: 8, y: 115.300003052 },
  { time: 9, y: 114.099998474 },
  { time: 10, y: 114.099998474 },
  { time: 11, y: 117.300003052 },
  { time: 12, y: 117.300003052 },
  { time: 13, y: 117.300003052 },
  { time: 14, y: 117.300003052 },
  { time: 15, y: 116.300003052 },
  { time: 16, y: 116.300003052 },
  { time: 17, y: 115.300003052 },
  { time: 18, y: 115.300003052 },
  { time: 19, y: 114.400001526 },
  { time: 20, y: 114.400001526 },
  { time: 21, y: 113.800003052 },
  { time: 22, y: 113.199996948 },
  { time: 23, y: 113.199996948 },
  { time: 24, y: 111.400001526 },
  { time: 25, y: 111.400001526 },
  { time: 26, y: 110 },
  { time: 27, y: 110 },
  { time: 28, y: 109.5 },
  { time: 29, y: 109.5 },
  { time: 30, y: 112.199996948 },
  { time: 31, y: 112.199996948 },
  { time: 32, y: 113.599998474 },
  { time: 33, y: 113.599998474 },
  { time: 34, y: 112.900001526 },
  { time: 35, y: 112.900001526 },
  { time: 36, y: 109.900001526 },
  { time: 37, y: 109.900001526 },
  { time: 38, y: 105.5 },
  { time: 39, y: 105.5 },
  { time: 40, y: 101.799999237 },
  { time: 41, y: 101.799999237 },
  { time: 42, y: 99 },
  { time: 43, y: 99 },
  { time: 44, y: 97.400001526 },
  { time: 45, y: 97.400001526 },
  { time: 46, y: 95.799999237 },
  { time: 47, y: 95.799999237 },
  { time: 48, y: 93.799999237 },
  { time: 49, y: 93.799999237 },
  { time: 50, y: 92.400001526 },
  { time: 51, y: 92.400001526 },
  { time: 52, y: 91 },
  { time: 53, y: 91 },
  { time: 54, y: 90.200000763 },
  { time: 55, y: 90.200000763 },
  { time: 56, y: 89.599998474 },
  { time: 57, y: 89.599998474 },
  { time: 58, y: 91.5 },
  { time: 59, y: 91.5 },
  { time: 60, y: 92.099998474 },
  { time: 61, y: 91.900001526 },
  { time: 62, y: 91.900001526 },
  { time: 63, y: 101.099998474 },
  { time: 64, y: 101.099998474 },
  { time: 65, y: 100.599998474 },
  { time: 66, y: 100.599998474 },
  { time: 67, y: 99.400001526 },
  { time: 68, y: 99.400001526 },
  { time: 69, y: 99.299999237 },
  { time: 70, y: 99.299999237 },
  { time: 71, y: 99.700000763 },
  { time: 72, y: 99.700000763 },
  { time: 73, y: 100.099998474 },
  { time: 74, y: 100.099998474 },
  { time: 75, y: 100.700000763 },
  { time: 76, y: 100.700000763 },
  { time: 77, y: 101.299999237 },
  { time: 78, y: 101.299999237 },
  { time: 79, y: 101.700000763 },
  { time: 80, y: 101.700000763 },
  { time: 81, y: 102.599998474 },
  { time: 82, y: 102.599998474 },
  { time: 83, y: 103 },
  { time: 84, y: 103 },
  { time: 85, y: 102.099998474 },
  { time: 86, y: 102.099998474 },
  { time: 87, y: 101.599998474 },
  { time: 88, y: 101.599998474 },
  { time: 89, y: 101.5 },
  { time: 90, y: 101.5 },
  { time: 91, y: 101.599998474 },
  { time: 92, y: 101.599998474 },
  { time: 93, y: 101.799999237 },
  { time: 94, y: 101.799999237 },
  { time: 95, y: 102 },
  { time: 96, y: 102 },
  { time: 97, y: 103.400001526 },
  { time: 98, y: 103.400001526 },
  { time: 99, y: 105.599998474 },
  { time: 100, y: 105.599998474 }
]

// ----------Humidity  Array--------------------
const humidArray = [
  { time: 1, y: 74.599998 },
  { time: 2, y: 74.199997 },
  { time: 3, y: 73.800003 },
  { time: 4, y: 73.800003 },
  { time: 5, y: 73.5 },
  { time: 6, y: 73.5 },
  { time: 7, y: 73.300003 },
  { time: 8, y: 73.300003 },
  { time: 9, y: 72.099998 },
  { time: 10, y: 72.099998 },
  { time: 11, y: 75.300003 },
  { time: 12, y: 75.300003 },
  { time: 13, y: 75.300003 },
  { time: 14, y: 75.300003 },
  { time: 15, y: 74.300003 },
  { time: 16, y: 74.300003 },
  { time: 17, y: 73.300003 },
  { time: 18, y: 73.300003 },
  { time: 19, y: 72.400002 },
  { time: 20, y: 72.400002 },
  { time: 21, y: 71.199997 },
  { time: 22, y: 71.199997 },
  { time: 23, y: 69.400002 },
  { time: 24, y: 69.400002 },
  { time: 25, y: 68 },
  { time: 26, y: 68 },
  { time: 27, y: 67.5 },
  { time: 28, y: 67.5 },
  { time: 29, y: 70.199997 },
  { time: 30, y: 70.199997 },
  { time: 31, y: 71.599998 },
  { time: 32, y: 71.599998 },
  { time: 33, y: 70.900002 },
  { time: 34, y: 70.900002 },
  { time: 35, y: 67.900002 },
  { time: 36, y: 67.900002 },
  { time: 37, y: 63.5 },
  { time: 38, y: 63.5 },
  { time: 39, y: 59.799999 },
  { time: 40, y: 59.799999 },
  { time: 41, y: 57 },
  { time: 42, y: 57 },
  { time: 43, y: 55.400002 },
  { time: 44, y: 55.400002 },
  { time: 45, y: 53.799999 },
  { time: 46, y: 53.799999 },
  { time: 47, y: 51.799999 },
  { time: 48, y: 51.799999 },
  { time: 49, y: 50.400002 },
  { time: 50, y: 50.400002 },
  { time: 51, y: 49 },
  { time: 52, y: 49 },
  { time: 53, y: 48.200001 },
  { time: 54, y: 48.200001 },
  { time: 55, y: 47.599998 },
  { time: 56, y: 47.599998 },
  { time: 57, y: 49.5 },
  { time: 58, y: 49.5 },
  { time: 59, y: 50.099998 },
  { time: 60, y: 50.099998 },
  { time: 61, y: 49.900002 },
  { time: 62, y: 49.900002 },
  { time: 63, y: 59.099998 },
  { time: 64, y: 59.099998 },
  { time: 65, y: 58.599998 },
  { time: 66, y: 58.599998 },
  { time: 67, y: 57.400002 },
  { time: 68, y: 57.400002 },
  { time: 69, y: 57.299999 },
  { time: 70, y: 57.299999 },
  { time: 71, y: 57.700001 },
  { time: 72, y: 57.700001 },
  { time: 73, y: 58.099998 },
  { time: 74, y: 58.099998 },
  { time: 75, y: 58.700001 },
  { time: 76, y: 58.700001 },
  { time: 77, y: 59.299999 },
  { time: 78, y: 59.299999 },
  { time: 79, y: 59.700001 },
  { time: 80, y: 59.700001 },
  { time: 81, y: 60.599998 },
  { time: 82, y: 60.599998 },
  { time: 83, y: 61 },
  { time: 84, y: 61 },
  { time: 85, y: 60.099998 },
  { time: 86, y: 60.099998 },
  { time: 87, y: 59.599998 },
  { time: 88, y: 59.599998 },
  { time: 89, y: 59.5 },
  { time: 90, y: 59.5 },
  { time: 91, y: 59.599998 },
  { time: 92, y: 59.599998 },
  { time: 93, y: 59.799999 },
  { time: 94, y: 59.799999 },
  { time: 95, y: 60 },
  { time: 96, y: 60 },
  { time: 97, y: 61.400002 },
  { time: 98, y: 61.400002 },
  { time: 99, y: 63.599998 },
  { time: 100, y: 63.599998 }
]

// ----------Room Temp  Array--------------------
const roomTempArray = [
  { time: 1, y: 33.93000030517578 },
  { time: 2, y: 33.93000030517578 },
  { time: 3, y: 33.869998931884766 },
  { time: 4, y: 33.81999969482422 },
  { time: 5, y: 33.790000915527344 },
  { time: 6, y: 33.77000045776367 },
  { time: 7, y: 33.720001220703125 },
  { time: 8, y: 33.709999084472656 },
  { time: 9, y: 33.689998626708984 },
  { time: 10, y: 33.689998626708984 },
  { time: 11, y: 33.68000030517578 },
  { time: 12, y: 33.68000030517578 },
  { time: 13, y: 33.68000030517578 },
  { time: 14, y: 33.689998626708984 },
  { time: 15, y: 33.70000076293945 },
  { time: 16, y: 33.72999954223633 },
  { time: 17, y: 33.72999954223633 },
  { time: 18, y: 33.720001220703125 },
  { time: 19, y: 33.720001220703125 },
  { time: 20, y: 33.630001068115234 },
  { time: 21, y: 33.63999938964844 },
  { time: 22, y: 33.63999938964844 },
  { time: 23, y: 33.630001068115234 },
  { time: 24, y: 33.63999938964844 },
  { time: 25, y: 33.63999938964844 },
  { time: 26, y: 33.630001068115234 },
  { time: 27, y: 33.630001068115234 },
  { time: 28, y: 33.63999938964844 },
  { time: 29, y: 33.63999938964844 },
  { time: 30, y: 33.65999984741211 },
  { time: 31, y: 33.65999984741211 },
  { time: 32, y: 33.66999816894531 },
  { time: 33, y: 33.689998626708984 },
  { time: 34, y: 33.709999084472656 },
  { time: 35, y: 33.720001220703125 },
  { time: 36, y: 33.7400016784668 },
  { time: 37, y: 33.75 },
  { time: 38, y: 33.7599983215332 },
  { time: 39, y: 33.83000183105469 },
  { time: 40, y: 33.83000183105469 },
  { time: 41, y: 33.84000015258789 },
  { time: 42, y: 33.849998474121094 },
  { time: 43, y: 33.849998474121094 },
  { time: 44, y: 33.81999969482422 },
  { time: 45, y: 33.810001373291016 },
  { time: 46, y: 33.81999969482422 },
  { time: 47, y: 33.83000183105469 },
  { time: 48, y: 33.83000183105469 },
  { time: 49, y: 33.849998474121094 },
  { time: 50, y: 33.86000061035156 },
  { time: 51, y: 33.849998474121094 },
  { time: 52, y: 33.869998931884766 },
  { time: 53, y: 33.88999938964844 },
  { time: 54, y: 33.900001525878906 },
  { time: 55, y: 33.90999984741211 },
  { time: 56, y: 33.90999984741211 },
  { time: 57, y: 33.91999816894531 },
  { time: 58, y: 33.95000076293945 },
  { time: 59, y: 33.959999084472656 },
  { time: 60, y: 33.970001220703125 },
  { time: 61, y: 33.97999954223633 },
  { time: 62, y: 33.9900016784668 },
  { time: 63, y: 33.9900016784668 },
  { time: 64, y: 34.0099983215332 },
  { time: 65, y: 34 },
  { time: 66, y: 34.0099983215332 },
  { time: 67, y: 33.939998626708984 },
  { time: 68, y: 33.95000076293945 },
  { time: 69, y: 33.97999954223633 },
  { time: 70, y: 33.97999954223633 },
  { time: 71, y: 33.9900016784668 },
  { time: 72, y: 34 },
  { time: 73, y: 34.0099983215332 },
  { time: 74, y: 34.0099983215332 },
  { time: 75, y: 34.040000915527344 },
  { time: 76, y: 34.029998779296875 },
  { time: 77, y: 34.150001525878906 },
  { time: 78, y: 34.16999816894531 },
  { time: 79, y: 34.189998626708984 },
  { time: 80, y: 34.189998626708984 },
  { time: 81, y: 34.209999084472656 },
  { time: 82, y: 34.209999084472656 },
  { time: 83, y: 34.220001220703125 },
  { time: 84, y: 34.22999954223633 },
  { time: 85, y: 34.22999954223633 },
  { time: 86, y: 34.2400016784668 },
  { time: 87, y: 34.2400016784668 },
  { time: 88, y: 34.2400016784668 },
  { time: 89, y: 34.25 },
  { time: 90, y: 34.25 },
  { time: 91, y: 34.25 },
  { time: 92, y: 34.25 },
  { time: 93, y: 34.25 },
  { time: 94, y: 34.2599983215332 },
  { time: 95, y: 34.2599983215332 },
  { time: 96, y: 34.27000045776367 },
  { time: 97, y: 34.27000045776367 },
  { time: 98, y: 34.2599983215332 },
  { time: 99, y: 34.209999084472656 },
  { time: 100, y: 34.18000030517578 }
]


// ----------Blood OX Array--------------------
const bloodOxArray = [
  { time: 1, y: 96 },
  { time: 2, y: 97 },
  { time: 3, y: 97 },
  { time: 4, y: 98 },
  { time: 5, y: 96 },
  { time: 6, y: 97 },
  { time: 7, y: 96 },
  { time: 8, y: 98 },
  { time: 9, y: 0 },
  { time: 10, y: 0 },
  { time: 11, y: 0 },
  { time: 12, y: 0 },
  { time: 13, y: 0 },
  { time: 14, y: 0 },
  { time: 15, y: 96 },
  { time: 16, y: 96 },
  { time: 17, y: 98 },
  { time: 18, y: 96 },
  { time: 19, y: 99 },
  { time: 20, y: 98 },
  { time: 21, y: 97 },
  { time: 22, y: 99 },
  { time: 23, y: 97 },
  { time: 24, y: 97 },
  { time: 25, y: 98 },
  { time: 26, y: 96 },
  { time: 27, y: 98 },
  { time: 28, y: 0 },
  { time: 29, y: 0 },
  { time: 30, y: 0 },
  { time: 31, y: 0 },
  { time: 32, y: 0 },
  { time: 33, y: 97 },
  { time: 34, y: 99 },
  { time: 35, y: 98 },
  { time: 36, y: 99 },
  { time: 37, y: 97 },
  { time: 38, y: 96 },
  { time: 39, y: 97 },
  { time: 40, y: 96 },
  { time: 41, y: 99 },
  { time: 42, y: 99 },
  { time: 43, y: 98 },
  { time: 44, y: 98 },
  { time: 45, y: 98 },
  { time: 46, y: 0 },
  { time: 47, y: 0 },
  { time: 48, y: 0 },
  { time: 49, y: 0 },
  { time: 50, y: 96 },
  { time: 51, y: 97 },
  { time: 52, y: 96 },
  { time: 53, y: 96 },
  { time: 54, y: 98 },
  { time: 55, y: 98 },
  { time: 56, y: 99 },
  { time: 57, y: 98 },
  { time: 58, y: 98 },
  { time: 59, y: 0 },
  { time: 60, y: 0 },
  { time: 61, y: 0 },
  { time: 62, y: 0 },
  { time: 63, y: 0 },
  { time: 64, y: 0 },
  { time: 65, y: 96 },
  { time: 66, y: 96 },
  { time: 67, y: 98 },
  { time: 68, y: 98 },
  { time: 69, y: 96 },
  { time: 70, y: 98 },
  { time: 71, y: 97 },
  { time: 72, y: 99 },
  { time: 73, y: 97 },
  { time: 74, y: 96 },
  { time: 75, y: 98 },
  { time: 76, y: 98 },
  { time: 77, y: 97 },
  { time: 78, y: 0 },
  { time: 79, y: 0 },
  { time: 80, y: 0 },
  { time: 81, y: 0 },
  { time: 82, y: 0 },
  { time: 83, y: 0 },
  { time: 84, y: 97 },
  { time: 85, y: 96 },
  { time: 86, y: 98 },
  { time: 87, y: 97 },
  { time: 88, y: 96 },
  { time: 89, y: 97 },
  { time: 90, y: 97 },
  { time: 91, y: 98 },
  { time: 92, y: 97 },
  { time: 93, y: 97 },
  { time: 94, y: 0 },
  { time: 95, y: 0 },
  { time: 96, y: 0 },
  { time: 97, y: 0 },
  { time: 98, y: 0 },
  { time: 99, y: 0 },
  { time: 100, y: 98 }
]

// ----------Sytolic Array--------------------
const systolicArray = [
  { time: 1, y: 0 },
  { time: 2, y: 0 },
  { time: 3, y: 0 },
  { time: 4, y: 0 },
  { time: 5, y: 0 },
  { time: 6, y: 0 },
  { time: 7, y: 0 },
  { time: 8, y: 0 },
  { time: 9, y: 137 },
  { time: 10, y: 135 },
  { time: 11, y: 135 },
  { time: 12, y: 138 },
  { time: 13, y: 140 },
  { time: 14, y: 136 },
  { time: 15, y: 138 },
  { time: 16, y: 136 },
  { time: 17, y: 138 },
  { time: 18, y: 0 },
  { time: 19, y: 0 },
  { time: 20, y: 0 },
  { time: 21, y: 0 },
  { time: 22, y: 0 },
  { time: 23, y: 0 },
  { time: 24, y: 0 },
  { time: 25, y: 0 },
  { time: 26, y: 0 },
  { time: 27, y: 0 },
  { time: 28, y: 113 },
  { time: 29, y: 114 },
  { time: 30, y: 114 },
  { time: 31, y: 114 },
  { time: 32, y: 116 },
  { time: 33, y: 114 },
  { time: 34, y: 114 },
  { time: 35, y: 114 },
  { time: 36, y: 114 },
  { time: 37, y: 0 },
  { time: 38, y: 0 },
  { time: 39, y: 0 },
  { time: 40, y: 0 },
  { time: 41, y: 0 },
  { time: 42, y: 0 },
  { time: 43, y: 0 },
  { time: 44, y: 0 },
  { time: 45, y: 0 },
  { time: 46, y: 0 },
  { time: 47, y: 129 },
  { time: 48, y: 129 },
  { time: 49, y: 129 },
  { time: 50, y: 129 },
  { time: 51, y: 128 },
  { time: 52, y: 129 },
  { time: 53, y: 129 },
  { time: 54, y: 129 },
  { time: 55, y: 122 },
  { time: 56, y: 0 },
  { time: 57, y: 0 },
  { time: 58, y: 0 },
  { time: 59, y: 0 },
  { time: 60, y: 0 },
  { time: 61, y: 0 },
  { time: 62, y: 0 },
  { time: 63, y: 0 },
  { time: 64, y: 0 },
  { time: 65, y: 0 },
  { time: 66, y: 114 },
  { time: 67, y: 117 },
  { time: 68, y: 117 },
  { time: 69, y: 114 },
  { time: 70, y: 119 },
  { time: 71, y: 117 },
  { time: 72, y: 120 },
  { time: 73, y: 122 },
  { time: 74, y: 122 },
  { time: 75, y: 0 },
  { time: 76, y: 0 },
  { time: 77, y: 0 },
  { time: 78, y: 0 },
  { time: 79, y: 0 },
  { time: 80, y: 0 },
  { time: 81, y: 0 },
  { time: 82, y: 0 },
  { time: 83, y: 0 },
  { time: 84, y: 0 },
  { time: 85, y: 113 },
  { time: 86, y: 111 },
  { time: 87, y: 116 },
  { time: 88, y: 117 },
  { time: 89, y: 117 },
  { time: 90, y: 117 },
  { time: 91, y: 114 },
  { time: 92, y: 114 },
  { time: 93, y: 117 },
  { time: 94, y: 0 },
  { time: 95, y: 0 },
  { time: 96, y: 0 },
  { time: 97, y: 0 },
  { time: 98, y: 0 },
  { time: 99, y: 0 },
  { time: 100, y: 0 }
]

// ----------Diastolic Array--------------------
const diastolicArray = [
  { time: 1, y: 0 },
  { time: 2, y: 0 },
  { time: 3, y: 0 },
  { time: 4, y: 0 },
  { time: 5, y: 0 },
  { time: 6, y: 0 },
  { time: 7, y: 0 },
  { time: 8, y: 0 },
  { time: 9, y: 81 },
  { time: 10, y: 80 },
  { time: 11, y: 80 },
  { time: 12, y: 82 },
  { time: 13, y: 73 },
  { time: 14, y: 74 },
  { time: 15, y: 76 },
  { time: 16, y: 74 },
  { time: 17, y: 82 },
  { time: 18, y: 0 },
  { time: 19, y: 0 },
  { time: 20, y: 0 },
  { time: 21, y: 0 },
  { time: 22, y: 0 },
  { time: 23, y: 0 },
  { time: 24, y: 0 },
  { time: 25, y: 0 },
  { time: 26, y: 0 },
  { time: 27, y: 0 },
  { time: 28, y: 70 },
  { time: 29, y: 71 },
  { time: 30, y: 71 },
  { time: 31, y: 71 },
  { time: 32, y: 72 },
  { time: 33, y: 71 },
  { time: 34, y: 71 },
  { time: 35, y: 71 },
  { time: 36, y: 71 },
  { time: 37, y: 0 },
  { time: 38, y: 0 },
  { time: 39, y: 0 },
  { time: 40, y: 0 },
  { time: 41, y: 0 },
  { time: 42, y: 0 },
  { time: 43, y: 0 },
  { time: 44, y: 0 },
  { time: 45, y: 0 },
  { time: 46, y: 0 },
  { time: 47, y: 71 },
  { time: 48, y: 71 },
  { time: 49, y: 71 },
  { time: 50, y: 71 },
  { time: 51, y: 70 },
  { time: 52, y: 71 },
  { time: 53, y: 71 },
  { time: 54, y: 71 },
  { time: 55, y: 81 },
  { time: 56, y: 0 },
  { time: 57, y: 0 },
  { time: 58, y: 0 },
  { time: 59, y: 0 },
  { time: 60, y: 0 },
  { time: 61, y: 0 },
  { time: 62, y: 0 },
  { time: 63, y: 0 },
  { time: 64, y: 0 },
  { time: 65, y: 0 },
  { time: 66, y: 71 },
  { time: 67, y: 73 },
  { time: 68, y: 73 },
  { time: 69, y: 71 },
  { time: 70, y: 74 },
  { time: 71, y: 73 },
  { time: 72, y: 75 },
  { time: 73, y: 76 },
  { time: 74, y: 76 },
  { time: 75, y: 0 },
  { time: 76, y: 0 },
  { time: 77, y: 0 },
  { time: 78, y: 0 },
  { time: 79, y: 0 },
  { time: 80, y: 0 },
  { time: 81, y: 0 },
  { time: 82, y: 0 },
  { time: 83, y: 0 },
  { time: 84, y: 0 },
  { time: 85, y: 70 },
  { time: 86, y: 69 },
  { time: 87, y: 72 },
  { time: 88, y: 73 },
  { time: 89, y: 73 },
  { time: 90, y: 73 },
  { time: 91, y: 71 },
  { time: 92, y: 71 },
  { time: 93, y: 73 },
  { time: 94, y: 0 },
  { time: 95, y: 0 },
  { time: 96, y: 0 },
  { time: 97, y: 0 },
  { time: 98, y: 0 },
  { time: 99, y: 0 },
  { time: 100, y: 0 }
]

// ----------Body Temp Array--------------------
const bodyTempArray = [
  { time: 1, y: 31.299999 },
  { time: 2, y: 31.299999 },
  { time: 3, y: 31.4 },
  { time: 4, y: 31.4 },
  { time: 5, y: 31.4 },
  { time: 6, y: 31.4 },
  { time: 7, y: 31.4 },
  { time: 8, y: 31.4 },
  { time: 9, y: 31.700001 },
  { time: 10, y: 31.700001 },
  { time: 11, y: 31.9 },
  { time: 12, y: 32 },
  { time: 13, y: 32 },
  { time: 14, y: 32.200001 },
  { time: 15, y: 32.200001 },
  { time: 16, y: 32.299999 },
  { time: 17, y: 32.299999 },
  { time: 18, y: 32.400002 },
  { time: 19, y: 32.400002 },
  { time: 20, y: 32.5 },
  { time: 21, y: 32.799999 },
  { time: 22, y: 32.799999 },
  { time: 23, y: 34.099998 },
  { time: 24, y: 34.099998 },
  { time: 25, y: 34.299999 },
  { time: 26, y: 34.299999 },
  { time: 27, y: 34.900002 },
  { time: 28, y: 34.900002 },
  { time: 29, y: 35.5 },
  { time: 30, y: 35.5 },
  { time: 31, y: 36.400002 },
  { time: 32, y: 36.400002 },
  { time: 33, y: 37.299999 },
  { time: 34, y: 37.299999 },
  { time: 35, y: 38.200001 },
  { time: 36, y: 38.200001 },
  { time: 37, y: 39 },
  { time: 38, y: 39 },
  { time: 39, y: 39.5 },
  { time: 40, y: 39.799999 },
  { time: 41, y: 39.799999 },
  { time: 42, y: 41.099998 },
  { time: 43, y: 41.099998 },
  { time: 44, y: 41.099998 },
  { time: 45, y: 41.099998 },
  { time: 46, y: 41.099998 },
  { time: 47, y: 41.099998 },
  { time: 48, y: 42.400002 },
  { time: 49, y: 42.400002 },
  { time: 50, y: 42.400002 },
  { time: 51, y: 42.400002 },
  { time: 52, y: 42.400002 },
  { time: 53, y: 42.400002 },
  { time: 54, y: 42.299999 },
  { time: 55, y: 42.299999 },
  { time: 56, y: 42.299999 },
  { time: 57, y: 42.299999 },
  { time: 58, y: 41.5 },
  { time: 59, y: 41.5 },
  { time: 60, y: 41.099998 },
  { time: 61, y: 41.099998 },
  { time: 62, y: 38.400002 },
  { time: 63, y: 38.400002 },
  { time: 64, y: 38 },
  { time: 65, y: 38 },
  { time: 66, y: 37.700001 },
  { time: 67, y: 37.700001 },
  { time: 68, y: 37.299999 },
  { time: 69, y: 37.299999 },
  { time: 70, y: 37.299999 },
  { time: 71, y: 37.099998 },
  { time: 72, y: 37.099998 },
  { time: 73, y: 36.799999 },
  { time: 74, y: 36.799999 },
  { time: 75, y: 36.599998 },
  { time: 76, y: 36.599998 },
  { time: 77, y: 36.299999 },
  { time: 78, y: 36.299999 },
  { time: 79, y: 36.099998 },
  { time: 80, y: 36.099998 },
  { time: 81, y: 36.099998 },
  { time: 82, y: 36.099998 },
  { time: 83, y: 36.900002 },
  { time: 84, y: 36.900002 },
  { time: 85, y: 36.900002 },
  { time: 86, y: 36.900002 },
  { time: 87, y: 36.799999 },
  { time: 88, y: 36.799999 },
  { time: 89, y: 36.700001 },
  { time: 90, y: 36.700001 },
  { time: 91, y: 36.599998 },
  { time: 92, y: 36.599998 },
  { time: 93, y: 36.5 },
  { time: 94, y: 36.5 },
  { time: 95, y: 36.299999 },
  { time: 96, y: 36.299999 },
  { time: 97, y: 36.400002 },
  { time: 98, y: 36.400002 },
  { time: 99, y: 36.799999 },
  { time: 100, y: 36.799999 }
]




var updateInterval = 1000;
var xValHeartRate = 1;
var xValHeartRateH1R1 = 1;
var xValHeartRateH1R2 = 1;
var xValHeartRateH1R3 = 1;
var xValHeartRateH1R4 = 1;
var xValHeartRateH2R1 = 1;
var xValHeartRateH2R2 = 1;
var xValMq2Data = mq2Array.length + 1;
var xValBloodOX = bloodOxArray.length + 1;
var xValBloodOXH1R1 = 151;
var xValBloodOXH1R2 = 151;
var xValBloodOXH1R3 = 151;
var xValBloodOXH1R4 = 151;
var xValBloodOXH2R1 = 151;
var xValBloodOXH2R2 = 151;
var xValSystolic = systolicArray.length + 1;
var xValSystolicH1R1 = 151;
var xValSystolicH1R2 = 151;
var xValSystolicH1R3 = 151;
var xValSystolicH1R4 = 151;
var xValSystolicH2R1 = 151;
var xValSystolicH2R2 = 151;
var xValDiastolic = diastolicArray.length + 1
var xValDiastolicH1R1 = 151;
var xValDiastolicH1R1 = 151;
var xValDiastolicH1R2 = 151;
var xValDiastolicH1R3 = 151;
var xValDiastolicH1R4 = 151;
var xValDiastolicH2R1 = 151;
var xValDiastolicH2R2 = 151;
var xValBodyTemp = bodyTempArray.length + 1
var xValBodyTempH1R1 = 151
var xValBodyTempH1R2 = 151
var xValBodyTempH1R3 = 151
var xValBodyTempH1R4 = 151
var xValBodyTempH2R1 = 151
var xValBodyTempH2R2 = 151
var xValMq9Data = mq9Array.length + 1
var xValMq135Data = mq135Array.length + 1
var humidityData = mq135Array.length + 1
var roomTempData = mq135Array.length + 1





class ChartsClass extends Component {



  state = {
    name: 0,
    emotion: 0,
    timestamp: 0,
    emoValue: 0,
    mq2Value: 0,
    mq2Value1: 0,
    mq9Value: 0,
    mq9Value1: 0,
    mq135Value: 0,
    mq135Value1: 0,
    tempValue: 0,
    tempValue1: 0,
    humidValue: 0,
    humidValue: 0,
    bodyTempValue: 0,
    bodyTempValue1: 0,
    bodyHeartRateValue: 0,
    bodyHeartRateValue1: 0,
    bodyOxValue: 0,
    bodyOxValue1: 0,
    bodyDysValue: 0,
    bodyDysValue1: 0,
    bodySysValue: 0,
    bodySysValue1: 0,
    plotPointsMq2: [],
    plotPointsMq9: [],
    plotPointsMq135: [],
    plotPointsRoomTemp: [],
    plotPointsHumid: [],
    plotPointsBodyTemp: [],
    bodyTempH1R1: [],
    bodyTempH1R2: [],
    bodyTempH1R3: [],
    bodyTempH1R4: [],
    bodyTempH2R1: [],
    bodyTempH2R2: [],
    bodyTempHxRy: [],
    bodyTempTimestamp: [],
    plotPointsBloodOxygen: [],
    bloodOxH1R1: [],
    bloodOxH1R2: [],
    bloodOxH1R3: [],
    bloodOxH1R4: [],
    bloodOxH2R1: [],
    bloodOxH2R2: [],
    bloodOxygenTimestamp: [],
    plotPointsBloodPressureDiastolic: [],
    diastolicH1R1: [],
    diastolicH1R2: [],
    diastolicH1R3: [],
    diastolicH1R4: [],
    diastolicH2R1: [],
    diastolicH2R2: [],
    bloodPressureDiastolicTimestamp: [],
    plotPointsBloodPressureSystolic: [],
    systolicH1R1: [],
    systolicH1R2: [],
    systolicH1R3: [],
    systolicH1R4: [],
    systolicH2R1: [],
    systolicH2R2: [],
    bloodPressureSystolicTimestamp: [],
    plotPointsHeartRate: [],
    heartRateH1R1: [],
    heartRateH1R2: [],
    heartRateH1R3: [],
    heartRateH1R4: [],
    heartRateH2R1: [],
    heartRateH2R2: [],
    heartRateTimestamp: [],
    recurrent: [],
    currentDateTime: 0,

  };


  constructor(props) {
    super(props)
    this.getCurrentTime = this.getCurrentTime.bind(this);
    this.updateChart = this.updateChart.bind(this);
    this.hospitalId = this.props.match.params.hospitalId;
    this.roomId = this.props.match.params.roomId;
    if (this.hospitalId == 'hospital-2' && this.roomId == 'room-3' || this.roomId == 'room-4') {
      this.mq2Listen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/mq2`);
      this.mq9Listen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/mq9`);
      this.mq135Listen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/mq135`);
      this.tempListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/temp`);
      this.humidListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/humid`);
      this.bodyTempListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/body_temperature`);

      this.bodyOxListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/blood_oxygen`);
      this.dysBPListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/heart_rate`);
      this.sysBPListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/blood_pressure_systolic`);
      this.dysListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/blood_pressure_diastolic`);
      this.nameListen = firebase.database().ref(this.props.match.params.id + '/Name');
      this.roomListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}`);
    } else {
      this.mq2Listen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/mq2`);
      this.mq9Listen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/mq9`);
      this.mq135Listen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/mq135`);
      this.tempListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/temp`);
      this.humidListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/room/humid`);

      this.bodyTempListen = firebase.database().ref(`/Hospitals/Hospital-2/Rooms/Room-3/sensorData/body/body_temperature`);
      this.bodyOxListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/blood_oxygen`);
      this.dysBPListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/heart_rate`);
      this.sysBPListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/blood_pressure_systolic`);
      this.dysListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}/sensorData/body/blood_pressure_diastolic`);
      this.nameListen = firebase.database().ref(this.props.match.params.id + '/Name');
      // this.roomListen = firebase.database().ref(`/Hospitals/${_.upperFirst(this.hospitalId)}/Rooms/${_.upperFirst(this.roomId)}`);
      this.roomListen = firebase.database().ref(`/Hospitals/Hospital-2/Rooms/Room-3`);

    }

  }


  timestampFormat(t) {
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    var month = monthNames[t.toString().split('-')[1] - 1]
    return month + " " + t.toString().split('-')[2]

  }

  getCurrentTime() {
    var currentTime = Date().toLocaleString().split(' ')[4]
    this.setState({ currentTime })
    return currentTime
  }


  mostFrequent(arr, n) {
    // Insert all elements in hash.
    var hash = new Map();
    for (var i = 0; i < n; i++) {
      if (hash.has(arr[i]))
        hash.set(arr[i], hash.get(arr[i]) + 1)
      else
        hash.set(arr[i], 1)
    }

    // find the max frequency
    var max_count = 0, res = -1;
    hash.forEach((value, key) => {

      if (max_count < value) {
        res = key;
        max_count = value;
      }

    });

    return res;
  }




  componentDidMount() {


    const listener = setInterval(this.updateChart, updateInterval);
    this.setState({ listener: listener })
    // const timeLabel = setInterval(() => this.setState({ currentTime: Date().toLocaleString().split(' ')[4] }), 1000)
    const timeLabel = setInterval(this.getCurrentTime, 1000)
    this.setState({ timeLabel: timeLabel })
    console.log(this.getCurrentTime())
    console.log(this.state.currentTime)
    // ----------Time---------------
    var currentDateTime = Date().toLocaleString()
    this.setState({ currentDateTime })
    // var mq2Value,mq9Value,mq135Value,tempValue,humidValue,value,bodyHeartRateValue,bodyOxValue,bodyTempValue,mq2Value1,bodyOxValue1,bodyHeartRateValue1,bodyTempValue1, humidValue1, value1; 
    // var sysBPArray = firebase.database().ref('Hospitals/Hospital-2/Rooms/Room-3/sensorData/body/blood_pressure_systolic').startr(100)
    this.mq2Listen.on('value', (snapshot) => {
      var mq2Value, mq2Value1
      mq2Value = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.value : snapshot.val()).toFixed(1);
      // document.getElementById("mq2Value").innerHTML = mq2Value;
      console.log(snapshot.val())
      console.log(mq2Value);
      console.log(this.props.match.params.id)
      this.setState({ mq2Value })
      mq2Value1 = (mq2Value - 50) / (10000 - 50)
      this.setState({ mq2Value1 })
      document.getElementById("mq2Value").innerHTML = mq2Value;


      //  set actual value

    });
    // window.onload = function() {

    //   what();

    //   function what() {
    //     document.getElementById("mq2Value").innerHTML = this.state.mq2Value;
    //   };

    // }
    this.mq9Listen.on('value', (snapshot) => {
      var mq9Value, mq9Value1
      mq9Value = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.value : snapshot.val()).toFixed(1);
      //   document.getElementById("mq9Value").innerHTML = mq9Value;

      this.setState({ mq9Value })
      mq9Value1 = (mq9Value - 20) / (5000 - 20)
      this.setState({ mq9Value1 })
      document.getElementById("mq9Value").innerHTML = mq9Value;
      //sconsole.log(mq2Value);
      // gaugemq9.percent=mq9Value; // set actual value
    });

    // window.onload = function() {

    //   what();

    //   function what() {
    //     document.getElementById("mq9Value").innerHTML = this.state.mq9Value;
    //   };

    // }
    this.mq135Listen.on('value', (snapshot) => {
      var mq135Value, mq135Value1
      mq135Value = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.value : snapshot.val()).toFixed(1);
      this.setState({ mq135Value })
      mq135Value1 = (mq135Value - 100) / (1500 - 100);
      this.setState({ mq135Value1 })

      document.getElementById("mq135Value").innerHTML = mq135Value;
      //   document.getElementById("mq135Value").innerHTML = mq135Value;

      //sconsole.log(mq2Value);
      // gaugemq135.percent=mq135Value; // set actual value
    });

    // window.onload = function() {

    //   what();

    //   function what() {
    //     document.getElementById("mq135Value").innerHTML = this.state.mq135Value;
    //   };

    // }

    this.tempListen.on('value', (snapshot) => {
      var tempValue, tempValue1
      tempValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.value : snapshot.val()).toFixed(1);
      //   document.getElementById("tempValue").innerHTML = tempValue;

      //sconsole.log(mq2Value);
      // gaugetemp.percent=tempValue; // set actual value
      this.setState({ tempValue })
      tempValue1 = (tempValue - 25) / (55 - 25)
      this.setState({ tempValue1 })

      document.getElementById("tempValue").innerHTML = tempValue;
    });

    //  window.onload = function() {

    //   what();

    //   function what() {
    //     document.getElementById("tempValue").innerHTML = this.state.tempValue;
    //   };

    // }

    this.humidListen.on('value', (snapshot) => {
      var humidValue, humidValue1
      humidValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.value : snapshot.val()).toFixed(1);
      //    document.getElementById("humidValue").innerHTML = humidValue;

      this.setState({ humidValue })
      humidValue1 = (humidValue - 20) / (100 - 20)
      this.setState({ humidValue1 })

      document.getElementById("humidValue").innerHTML = humidValue;
      //sconsole.log(mq2Value);
      //  gaugehumid.percent=humidValue; // set actual value
    });

    //  window.onload = function() {

    //   what();

    //   function what() {
    //     document.getElementById("humidValue").innerHTML = this.state.humidValue;
    //   };

    // }

    this.bodyTempListen.on('value', (snapshot) => {
      var bodyTempValue, bodyTempValue1
      bodyTempValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.Value : snapshot.val());
      // console.log(snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]].Value);
      //   document.getElementById("bodyTempValue").innerHTML = value;
      bodyTempValue = (bodyTempValue * 9 / 5) + 32
      // bodyTempValue = bodyTempValue.toFixed(2);
      this.setState({ bodyTempValue })
      bodyTempValue1 = (bodyTempValue - 80) / (110 - 92)

      console.log(bodyTempValue1)
      this.setState({ bodyTempValue1 })

      document.getElementById("bodyTempValue").innerHTML = bodyTempValue;
    });

    this.bodyOxListen.on('value', (snapshot) => {
      var bodyOxValue, bodyOxValue1
      bodyOxValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.Value : snapshot.val());
      //   document.getElementById("bodyOxValue").innerHTML = value;
      this.setState({ bodyOxValue })
      bodyOxValue1 = (bodyOxValue - 60) / (100 - 60)
      // bodyOxValue1 = bodyOxValue/100
      this.setState({ bodyOxValue1 })

      document.getElementById("bodyOxValue").innerHTML = bodyOxValue;
    });

    this.dysBPListen.on('value', (snapshot) => {
      var bodyHeartRateValue, bodyHeartRateValue1
      bodyHeartRateValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.Value : snapshot.val());
      // document.getElementById("bodyHeartRateValue").innerHTML = value;

      this.setState({ bodyHeartRateValue })
      bodyHeartRateValue1 = (bodyHeartRateValue - 40) / (150 - 40)
      this.setState({ bodyHeartRateValue1 })

      document.getElementById("bodyHeartRateValue").innerHTML = bodyHeartRateValue;
    });

    this.sysBPListen.on('value', (snapshot) => {
      var bodySysValue, bodySysValue1
      bodySysValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.Value : snapshot.val());
      // document.getElementById("bodyHeartRateValue").innerHTML = value;

      this.setState({ bodySysValue })
      // bodySysValue1=(bodySysValue - 40)/(150-40)
      bodySysValue1 = bodySysValue
      this.setState({ bodySysValue1 })

      document.getElementById("bodySysBP").innerHTML = bodySysValue1;
    });



    this.dysListen.on('value', (snapshot) => {
      var bodyDysValue, bodyDysValue1
      bodyDysValue = ((typeof snapshot.val() === 'object' && snapshot.val() !== null) ? snapshot.val()[Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]]?.Value : snapshot.val());
      // document.getElementById("bodyHeartRateValue").innerHTML = value;

      this.setState({ bodyDysValue })
      // bodyDysValue1=(bodyHeartRateValue - 40)/(150-40)
      bodyDysValue1 = bodyDysValue
      this.setState({ bodyDysValue1 })

      document.getElementById("bodyDysBP").innerHTML = bodyDysValue1;
    });

    var emoListen = firebase.database().ref('Hospitals/Hospital-2/Rooms/Room-4/sensorData/body/Emotions/timestamp')
    emoListen.orderByKey().limitToLast(900).on('value', (snapshot) => {
      var list = [], emoValue, emotion, timestamp
      snapshot.forEach(function (emotion) {
        list.push(emotion.val())
      })
      emoValue = this.mostFrequent(list, 900)

      this.setState({
        emoValue
      }, () => {
        console.log(this.state.emoValue); // This is guaranteed to return the updated state. 
      });

      emoValue = emoValue.toString()
      emoValue = emoValue.split(",", 2)
      console.log(emoValue)

      timestamp = emoValue[1]
      timestamp = timestamp.toString()
      timestamp = timestamp.split(":", 4)
      timestamp = timestamp[1] + ":" + timestamp[2] + ":" + timestamp[3]
      timestamp = timestamp.split(" ", 3)
      timestamp = "Date: " + timestamp[1] + " " + ", Time: " + timestamp[2]

      this.setState({
        timestamp
      }, () => {
        console.log(this.state.timestamp); // This is guaranteed to return the updated state. 
      });

      document.getElementById("Timestamp").innerHTML = timestamp;


      emotion = emoValue[0]
      emotion = emotion.toString()
      emotion = emotion.split(":", 2)
      emotion = emotion[1]

      this.setState({
        emotion
      }, () => {
        console.log(this.state.emotion); // This is guaranteed to return the updated state. 
      });

      document.getElementById("Emotion").innerHTML = emotion;
    })

    this.nameListen.on('value', (snapshot) => {
      var name
      name = snapshot.val();
      // document.getElementById("bodyHeartRateValue").innerHTML = value;

      this.setState({
        name
      }, () => {
        console.log(this.state.name); // This is guaranteed to return the updated state. 
      });

      document.getElementById("name").innerHTML = name;
    });

    // const chamberListen = firebase.database().ref('Chamber1');

    //     chamberListen.on("value", (snapshot) => {
    //      var chambers = [];

    //      var mq2Values=[],mq2Fetch, mq2Points = [], mq2Timestamp=[], plotPoints=[]
    //        var chamberKey = snapshot.key;
    //        var chamberData = snapshot.val();
    //        var result

    //        chambers.push({chamberKey, chamberData})
    //        console.log(chambers);

    //        mq2Fetch = Object.values(chamberData.room.mq2)
    //        console.log(mq2Fetch)


    //        //Mq2 Values Array
    //       mq2Fetch.forEach((object)=>{
    //         mq2Values.push(object.value)
    //       })
    //       console.log(mq2Values)

    //       // Mq2 Timestamp Array
    //       mq2Fetch.forEach((object)=> {
    //         mq2Timestamp.push(object.timestamp.toString().split(' ')[4])

    //       })
    //       console.log(mq2Timestamp)



    //        result =  mq2Values.reduce(function(result, field, index) {
    //          result[mq2Timestamp[index]] = field;
    //          return result;
    //        }, {})
    //        console.log(result)


    //        Array(result).forEach((object)=>{

    //          console.log(object.key)
    //        })

    //        mq2Fetch.forEach((object)=>{
    //         plotPoints.push(createData(object.timestamp.toString().split(' ')[4], object.value))
    //        })
    //        console.log(plotPoints)
    //        setChamberData(plotPoints)
    //  })




    // -------------------------------Graph Plot Points ------------------------------------------------------------------

    // ------MQ2----------

    this.roomListen.on("value", (snapshot) => {
      const rooms = [];

      var mq2Values = [], mq2Fetch, mq2Points = [], mq2Timestamp = [], plotPointsMq2 = []
      var mq9Values = [], mq9Fetch, mq9Points = [], mq9Timestamp = [], plotPointsMq9 = []
      var mq135Values = [], mq135Fetch, mq135Points = [], mq135Timestamp = [], plotPointsMq135 = []
      var roomTempValues = [], roomTempFetch, roomTempPoints = [], roomTempTimestamp = [], plotPointsRoomTemp = []
      var humidValues = [], humidFetch, humidPoints = [], humidTimestamp = [], plotPointsHumid = []
      var bodyTempValues = [], bodyTempFetch, bodyTempTimestamp = [], plotPointsBodyTemp = [], bodyTempH1R1 = [], bodyTempH1R2 = [], bodyTempH1R3 = [], bodyTempH1R4 = [], bodyTempH2R1 = [], bodyTempH2R2 = [], bodyTempHxRy = [], r1, r2
      var bloodOxygenValues = [], bloodOxygenFetch, bloodOxygenTimestamp = [], plotPointsBloodOxygen = [], bloodOxH1R1 = [], bloodOxH1R2 = [], bloodOxH1R3 = [], bloodOxH1R4 = [], bloodOxH2R1 = [], bloodOxH2R2 = []
      var bloodPressureDiastolicValues = [], bloodPressureDiastolicFetch, bloodPressureDiastolicTimestamp = [], plotPointsBloodPressureDiastolic = [], diastolicH1R1 = [], diastolicH1R2 = [], diastolicH1R3 = [], diastolicH1R4 = [], diastolicH2R1 = [], diastolicH2R2 = []
      var bloodPressureSystolicValues = [], bloodPressureSystolicFetch, bloodPressureSystolicTimestamp = [], plotPointsBloodPressureSystolic = [], systolicH1R1 = [], systolicH1R2 = [], systolicH1R3 = [], systolicH1R4 = [], systolicH2R1 = [], systolicH2R2 = []
      var heartRateValues = [], heartRateFetch, heartRateTimestamp = [], plotPointsHeartRate = [], heartRateH1R1 = [], heartRateH1R2 = [], heartRateH1R3 = [], heartRateH1R4 = [], heartRateH2R1 = [], heartRateH2R2 = []
      var recurrent = []
      var patientInfo;
      var roomKey = snapshot.key;
      var roomData = snapshot.val();
      var result

      rooms.push({ roomKey, roomData })
      console.log(rooms);

      // patientInfo = Object.values(roomData.info.patientName)
      // console.log(patientInfo)
      // document.getElementById("patientName").innerHTML = patientInfo;

      mq2Fetch = Object.values(roomData.sensorData.room.mq2)
      console.log(mq2Fetch)

      mq9Fetch = Object.values(roomData.sensorData.room.mq9)
      console.log(mq9Fetch)

      mq135Fetch = Object.values(roomData.sensorData.room.mq135)
      console.log(mq135Fetch)

      roomTempFetch = Object.values(roomData.sensorData.room.temp)
      console.log(mq135Fetch)

      humidFetch = Object.values(roomData.sensorData.room.humid)
      console.log(humidFetch)

      bodyTempFetch = Object.values(roomData.sensorData.body.body_temperature)
      console.log(bodyTempFetch)

      bloodOxygenFetch = Object.values(roomData.sensorData.body.blood_oxygen)
      console.log(bloodOxygenFetch)

      bloodPressureDiastolicFetch = Object.values(roomData.sensorData.body.blood_pressure_diastolic)
      console.log(bloodPressureDiastolicFetch)

      bloodPressureSystolicFetch = Object.values(roomData.sensorData.body.blood_pressure_systolic)
      console.log(bloodPressureSystolicFetch)

      heartRateFetch = Object.values(roomData.sensorData.body.heart_rate)
      console.log(heartRateFetch)



      //Mq2 Values Array
      mq2Fetch.forEach((object) => {
        mq2Values.push(object.value)
      })
      console.log(mq2Values)

      mq9Fetch.forEach((object) => {
        mq9Values.push(object.value)
      })
      console.log(mq9Values)

      mq135Fetch.forEach((object) => {
        mq135Values.push(object.value)
      })
      console.log(mq135Values)

      roomTempFetch.forEach((object) => {
        roomTempValues.push(object.value)
      })
      console.log(roomTempValues)

      humidFetch.forEach((object) => {
        humidValues.push(object.value)
      })
      console.log(humidValues)

      bodyTempFetch.forEach((object) => {
        bodyTempValues.push(object.Value)
      })
      console.log(bodyTempValues)

      bloodOxygenFetch.forEach((object) => {
        bloodOxygenValues.push(object.Value)
      })
      console.log(bloodOxygenValues)

      bloodPressureDiastolicFetch.forEach((object) => {
        bloodPressureDiastolicValues.push(object.Value)
      })
      console.log(bloodPressureDiastolicValues)

      bloodPressureSystolicFetch.forEach((object) => {
        bloodPressureSystolicValues.push(object.Value)
      })
      console.log(bloodPressureSystolicValues)

      heartRateFetch.forEach((object) => {
        heartRateValues.push(object.Value)
      })
      console.log(heartRateValues)





      // Mq2 Timestamp u
      mq2Fetch.forEach((object) => {
        mq2Timestamp.push(object.timestamp.toString().split(' ')[4])

      })
      console.log(mq2Timestamp)

      mq9Fetch.forEach((object) => {
        mq9Timestamp.push(object.timestamp.toString().split(' ')[4])

      })
      console.log(mq9Timestamp)

      mq135Fetch.forEach((object) => {
        mq135Timestamp.push(object.timestamp.toString().split(' ')[4])

      })
      console.log(mq135Timestamp)

      roomTempFetch.forEach((object) => {
        roomTempTimestamp.push(object.timestamp.toString().split(' ')[4])

      })
      console.log(roomTempTimestamp)

      humidFetch.forEach((object) => {
        humidTimestamp.push(object.timestamp.toString().split(' ')[4])

      })
      console.log(humidTimestamp)

      bodyTempFetch.forEach((object) => {
        bodyTempTimestamp.push(this.timestampFormat(object.Timestamp.toString().split(' ')[0]))

      })
      console.log(bodyTempTimestamp)
      this.setState({ bodyTempTimestamp })


      bloodOxygenFetch.forEach((object) => {
        bloodOxygenTimestamp.push(this.timestampFormat(object.Timestamp.toString().split(' ')[0]))

      })
      console.log(bloodOxygenTimestamp)
      this.setState({ bloodOxygenTimestamp })


      bloodPressureDiastolicFetch.forEach((object) => {
        bloodPressureDiastolicTimestamp.push(this.timestampFormat(object.Timestamp.toString().split(' ')[0]))

      })
      console.log(bloodPressureDiastolicTimestamp)
      this.setState({ bloodPressureDiastolicTimestamp })


      bloodPressureSystolicFetch.forEach((object) => {
        bloodPressureSystolicTimestamp.push(this.timestampFormat(object.Timestamp.toString().split(' ')[0]))

      })
      console.log(bloodPressureSystolicTimestamp)
      this.setState({ bloodPressureSystolicTimestamp })

      heartRateFetch.forEach((object) => {
        heartRateTimestamp.push(this.timestampFormat(object.Timestamp.toString().split(' ')[0]))

      })
      console.log(heartRateTimestamp)
      this.setState({ heartRateTimestamp })



      result = mq2Values.reduce(function (result, field, index) {
        result[mq2Timestamp[index]] = field;
        return result;
      }, {})
      console.log(result)


      Array(result).forEach((object) => {

        console.log(object.key)
      })

      mq2Fetch.forEach((object) => {
        plotPointsMq2.push(createData(object.timestamp.toString().split(' ')[4], object.value))
      })
      console.log(plotPointsMq2)
      this.setState({ plotPointsMq2 })


      // this.state.plotPointsMq2.forEach((object)=>{
      //   if(this.state.plotPointsMq2.length > 195){
      //     this.setState({recurrent: []})
      //     recurrent.push(createData(object.timestamp.toString().split(' ')[4], object.value))
      //     this.setState({recurrent })
      //   }
      //   else{
      //     this.state.recurrent = this.state.plotPointsMq2
      //   }
      // })

      mq9Fetch.forEach((object) => {
        plotPointsMq9.push(createData(object.timestamp.toString().split(' ')[4], object.value))
      })
      console.log(plotPointsMq9)
      this.setState({ plotPointsMq9 })

      mq135Fetch.forEach((object) => {
        plotPointsMq135.push(createData(object.timestamp.toString().split(' ')[4], object.value))
      })
      console.log(plotPointsMq135)
      this.setState({ plotPointsMq135 })

      roomTempFetch.forEach((object) => {
        plotPointsRoomTemp.push(createData(object.timestamp.toString().split(' ')[4], (object.value * 9 / 5) + 32))
      })
      console.log(plotPointsRoomTemp)
      this.setState({ plotPointsRoomTemp })

      humidFetch.forEach((object) => {
        plotPointsHumid.push(createData(object.timestamp.toString().split(' ')[4], object.value))
      })
      console.log(plotPointsHumid)
      this.setState({ plotPointsHumid })

      bodyTempFetch.forEach((object) => {
        var tempinf = (object.Value * 9 / 5) + 32
        // console.log(tempinf)
        plotPointsBodyTemp.push(createData(object.Timestamp.toString().split(' ')[1], tempinf))
        if (plotPointsBodyTemp.length > 150) {
          plotPointsBodyTemp.shift()
        }
      })



      bloodOxygenFetch.forEach((object) => {
        plotPointsBloodOxygen.push(createData(object.Timestamp.toString().split(' ')[1], object.Value))
        if (plotPointsBloodOxygen.length > 150) {
          plotPointsBloodOxygen.shift()
        }

      })
      console.log(plotPointsBloodOxygen)
      this.setState({ plotPointsBloodOxygen })

      bloodPressureDiastolicFetch.forEach((object) => {
        plotPointsBloodPressureDiastolic.push(createData(object.Timestamp.toString().split(' ')[1], object.Value))
        if (plotPointsBloodPressureDiastolic.length > 150) {
          plotPointsBloodPressureDiastolic.shift()
        }
      })
      console.log(plotPointsBloodPressureDiastolic)
      this.setState({ plotPointsBloodPressureDiastolic })

      bloodPressureSystolicFetch.forEach((object) => {
        plotPointsBloodPressureSystolic.push(createData(object.Timestamp.toString().split(' ')[1], object.Value))
        if (plotPointsBloodPressureSystolic.length > 150) {
          plotPointsBloodPressureSystolic.shift()
        }
      })
      console.log(plotPointsBloodPressureSystolic)
      this.setState({ plotPointsBloodPressureSystolic })

      heartRateFetch.forEach((object) => {
        plotPointsHeartRate.push(createData(object.Timestamp.toString().split(' ')[1], object.Value))
        if (plotPointsHeartRate.length > 150) {
          plotPointsHeartRate.shift()
        }
      })
      console.log(plotPointsHeartRate)
      this.setState({ plotPointsHeartRate })

      if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1') {
        // bodyTempHxRy.splice(0, bodyTempHxRy.length)
        // bodyTempHxRy = bodyTempH1R1
        // -----------------Body Temp---------------------
        bodyTempFetch.forEach((object) => {
          var tempinf = (object.Value * 9 / 5) + 32
          // console.log(tempinf)
          bodyTempH1R1.push(tempinf)
        })
        r1 = 0
        r2 = 149
        bodyTempH1R1 = bodyTempH1R1.slice(r1, r2)
        this.setState({ bodyTempH1R1 })
        console.log(bodyTempH1R1)

        // --------------Blood Oxygen----------------------
        bloodOxygenFetch.forEach((object) => {
          var bloodOxinf = object.Value
          // console.log(tempinf)
          bloodOxH1R1.push(bloodOxinf)
        })
        r1 = 0
        r2 = 149
        bloodOxH1R1 = bloodOxH1R1.slice(r1, r2)
        this.setState({ bloodOxH1R1 })
        console.log(bloodOxH1R1)

        // ---------------Diastolic------------------------
        bloodPressureDiastolicFetch.forEach((object) => {
          var diastolicinf = object.Value
          diastolicH1R1.push(diastolicinf)
        })
        r1 = 0
        r2 = 149
        diastolicH1R1 = diastolicH1R1.slice(r1, r2)
        this.setState({ diastolicH1R1 })
        console.log(diastolicH1R1)

        // ------------------Systolic---------------------------
        bloodPressureSystolicFetch.forEach((object) => {
          var systolicinf = object.Value
          systolicH1R1.push(systolicinf)
        })
        r1 = 0
        r2 = 149
        systolicH1R1 = systolicH1R1.slice(r1, r2)
        this.setState({ systolicH1R1 })
        console.log(systolicH1R1)

        // ---------------------Heart Rate------------------------
        heartRateFetch.forEach((object) => {
          var heartRateinf = object.Value
          heartRateH1R1.push(heartRateinf)
        })
        r1 = 0
        r2 = 149
        heartRateH1R1 = heartRateH1R1.slice(r1, r2)
        this.setState({ heartRateH1R1 })
        console.log(heartRateH1R1)

      } else if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2') {
        // bodyTempHxRy.splice(0, bodyTempHxRy.length)
        // bodyTempHxRy = bodyTempH1R2
        // -----------------Body Temp---------------------
        bodyTempFetch.forEach((object) => {
          var tempinf = (object.Value * 9 / 5) + 32
          // console.log(tempinf)
          bodyTempH1R2.push(tempinf)
        })
        r1 = 150
        r2 = 299
        bodyTempH1R2 = bodyTempH1R2.slice(r1, r2)
        this.setState({ bodyTempH1R2 })
        console.log(bodyTempH1R2)

        // --------------Blood Oxygen----------------------
        bloodOxygenFetch.forEach((object) => {
          var bloodOxinf = object.Value
          // console.log(tempinf)
          bloodOxH1R2.push(bloodOxinf)
        })
        r1 = 150
        r2 = 299
        bloodOxH1R2 = bloodOxH1R2.slice(r1, r2)
        this.setState({ bloodOxH1R2 })
        console.log(bloodOxH1R2)

        // ---------------Diastolic------------------------
        bloodPressureDiastolicFetch.forEach((object) => {
          var diastolicinf = object.Value
          diastolicH1R2.push(diastolicinf)
        })
        r1 = 150
        r2 = 299
        diastolicH1R2 = diastolicH1R2.slice(r1, r2)
        this.setState({ diastolicH1R2 })
        console.log(diastolicH1R2)

        // ------------------Systolic---------------------------
        bloodPressureSystolicFetch.forEach((object) => {
          var systolicinf = object.Value
          systolicH1R2.push(systolicinf)
        })
        r1 = 150
        r2 = 299
        systolicH1R2 = systolicH1R2.slice(r1, r2)
        this.setState({ systolicH1R2 })
        console.log(systolicH1R2)

        // ---------------------Heart Rate------------------------
        heartRateFetch.forEach((object) => {
          var heartRateinf = object.Value
          heartRateH1R2.push(heartRateinf)
        })
        r1 = 150
        r2 = 299
        heartRateH1R2 = heartRateH1R2.slice(r1, r2)
        this.setState({ heartRateH1R2 })
        console.log(heartRateH1R2)

      } else if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3') {
        // bodyTempHxRy.splice(0, bodyTempHxRy.length)
        // bodyTempHxRy = bodyTempH1R3
        // -----------------Body Temp---------------------       
        bodyTempFetch.forEach((object) => {
          var tempinf = (object.Value * 9 / 5) + 32
          // console.log(tempinf)
          bodyTempH1R3.push(tempinf)
        })
        r1 = 300
        r2 = 449
        bodyTempH1R3 = bodyTempH1R3.slice(r1, r2)
        this.setState({ bodyTempH1R3 })
        console.log(bodyTempH1R3)

        // --------------Blood Oxygen----------------------
        bloodOxygenFetch.forEach((object) => {
          var bloodOxinf = object.Value
          // console.log(tempinf)
          bloodOxH1R3.push(bloodOxinf)
        })
        r1 = 300
        r2 = 449
        bloodOxH1R3 = bloodOxH1R3.slice(r1, r2)
        this.setState({ bloodOxH1R3 })
        console.log(bloodOxH1R3)

        // ---------------Diastolic------------------------
        bloodPressureDiastolicFetch.forEach((object) => {
          var diastolicinf = object.Value
          diastolicH1R3.push(diastolicinf)
        })
        r1 = 300
        r2 = 449
        diastolicH1R3 = diastolicH1R3.slice(r1, r2)
        this.setState({ diastolicH1R3 })
        console.log(diastolicH1R3)

        // ------------------Systolic---------------------------
        bloodPressureSystolicFetch.forEach((object) => {
          var systolicinf = object.Value
          systolicH1R3.push(systolicinf)
        })
        r1 = 300
        r2 = 449
        systolicH1R3 = systolicH1R3.slice(r1, r2)
        this.setState({ systolicH1R3 })
        console.log(systolicH1R3)

        // ---------------------Heart Rate------------------------
        heartRateFetch.forEach((object) => {
          var heartRateinf = object.Value
          heartRateH1R3.push(heartRateinf)
        })
        r1 = 300
        r2 = 449
        heartRateH1R3 = heartRateH1R3.slice(r1, r2)
        this.setState({ heartRateH1R3 })
        console.log(heartRateH1R3)

      } else if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4') {
        // bodyTempHxRy.splice(0, bodyTempHxRy.length)
        // bodyTempHxRy = bodyTempH1R4
        // -----------------Body Temp---------------------       
        bodyTempFetch.forEach((object) => {
          var tempinf = (object.Value * 9 / 5) + 32
          // console.log(tempinf)
          bodyTempH1R4.push(tempinf)
        })
        r1 = 450
        r2 = 599
        bodyTempH1R4 = bodyTempH1R4.slice(r1, r2)
        this.setState({ bodyTempH1R4 })
        console.log(bodyTempH1R4)

        // --------------Blood Oxygen----------------------
        bloodOxygenFetch.forEach((object) => {
          var bloodOxinf = object.Value
          // console.log(tempinf)
          bloodOxH1R4.push(bloodOxinf)
        })
        r1 = 450
        r2 = 599
        bloodOxH1R4 = bloodOxH1R4.slice(r1, r2)
        this.setState({ bloodOxH1R4 })
        console.log(bloodOxH1R4)

        // ---------------Diastolic------------------------
        bloodPressureDiastolicFetch.forEach((object) => {
          var diastolicinf = object.Value
          diastolicH1R4.push(diastolicinf)
        })
        r1 = 450
        r2 = 599
        diastolicH1R4 = diastolicH1R4.slice(r1, r2)
        this.setState({ diastolicH1R4 })
        console.log(diastolicH1R4)

        // ------------------Systolic---------------------------
        bloodPressureSystolicFetch.forEach((object) => {
          var systolicinf = object.Value
          systolicH1R4.push(systolicinf)
        })
        r1 = 450
        r2 = 599
        systolicH1R4 = systolicH1R4.slice(r1, r2)
        this.setState({ systolicH1R4 })
        console.log(systolicH1R4)

        // ---------------------Heart Rate------------------------
        heartRateFetch.forEach((object) => {
          var heartRateinf = object.Value
          heartRateH1R4.push(heartRateinf)
        })
        r1 = 450
        r2 = 599
        heartRateH1R4 = heartRateH1R4.slice(r1, r2)
        this.setState({ heartRateH1R4 })
        console.log(heartRateH1R4)

      } else if (this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1') {
        // bodyTempHxRy.splice(0, bodyTempHxRy.length)
        // bodyTempHxRy = bodyTempH2R1
        // -----------------Body Temp---------------------      
        bodyTempFetch.forEach((object) => {
          var tempinf = (object.Value * 9 / 5) + 32
          // console.log(tempinf)
          bodyTempH2R1.push(tempinf)
        })
        r1 = 600
        r2 = 749
        bodyTempH2R1 = bodyTempH2R1.slice(r1, r2)
        this.setState({ bodyTempH2R1 })
        console.log(bodyTempH2R1)

        // --------------Blood Oxygen----------------------
        bloodOxygenFetch.forEach((object) => {
          var bloodOxinf = object.Value
          // console.log(tempinf)
          bloodOxH2R1.push(bloodOxinf)
        })
        r1 = 600
        r2 = 749
        bloodOxH2R1 = bloodOxH2R1.slice(r1, r2)
        this.setState({ bloodOxH2R1 })
        console.log(bloodOxH2R1)

        // ---------------Diastolic------------------------
        bloodPressureDiastolicFetch.forEach((object) => {
          var diastolicinf = object.Value
          diastolicH2R1.push(diastolicinf)
        })
        r1 = 600
        r2 = 749
        diastolicH2R1 = diastolicH2R1.slice(r1, r2)
        this.setState({ diastolicH2R1 })
        console.log(diastolicH2R1)

        // ------------------Systolic---------------------------
        bloodPressureSystolicFetch.forEach((object) => {
          var systolicinf = object.Value
          systolicH2R1.push(systolicinf)
        })
        r1 = 600
        r2 = 749
        systolicH2R1 = systolicH2R1.slice(r1, r2)
        this.setState({ systolicH2R1 })
        console.log(systolicH2R1)

        // ---------------------Heart Rate------------------------
        heartRateFetch.forEach((object) => {
          var heartRateinf = object.Value
          heartRateH2R1.push(heartRateinf)
        })
        r1 = 600
        r2 = 749
        heartRateH2R1 = heartRateH2R1.slice(r1, r2)
        this.setState({ heartRateH2R1 })
        console.log(heartRateH2R1)

      } else if (this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2') {
        // bodyTempHxRy.splice(0, bodyTempHxRy.length)
        // bodyTempHxRy = bodyTempH2R2
        // -----------------Body Temp---------------------       
        bodyTempFetch.forEach((object) => {
          var tempinf = (object.Value * 9 / 5) + 32
          // console.log(tempinf)
          bodyTempH2R2.push(tempinf)
        })
        r1 = 750
        r2 = 899
        bodyTempH2R2 = bodyTempH2R2.slice(r1, r2)
        this.setState({ bodyTempH2R2 })
        console.log(bodyTempH2R2)
        // --------------Blood Oxygen----------------------
        bloodOxygenFetch.forEach((object) => {
          var bloodOxinf = object.Value
          // console.log(tempinf)
          bloodOxH2R2.push(bloodOxinf)
        })
        r1 = 750
        r2 = 899
        bloodOxH2R2 = bloodOxH2R2.slice(r1, r2)
        this.setState({ bloodOxH2R2 })
        console.log(bloodOxH2R2)

      }

      // ---------------Diastolic------------------------
      bloodPressureDiastolicFetch.forEach((object) => {
        var diastolicinf = object.Value
        diastolicH2R2.push(diastolicinf)
      })
      r1 = 750
      r2 = 899
      diastolicH2R2 = diastolicH2R2.slice(r1, r2)
      this.setState({ diastolicH2R2 })
      console.log(diastolicH2R2)

      // ------------------Systolic---------------------------
      bloodPressureSystolicFetch.forEach((object) => {
        var systolicinf = object.Value
        systolicH2R2.push(systolicinf)
      })
      r1 = 750
      r2 = 899
      systolicH2R2 = systolicH2R2.slice(r1, r2)
      this.setState({ systolicH2R2 })
      console.log(systolicH2R2)

      // ---------------------Heart Rate------------------------
      heartRateFetch.forEach((object) => {
        var heartRateinf = object.Value
        heartRateH2R2.push(heartRateinf)
      })
      r1 = 750
      r2 = 899
      heartRateH2R2 = heartRateH2R2.slice(r1, r2)
      this.setState({ heartRateH2R2 })
      console.log(heartRateH2R2)

      // bodyTempFetch.forEach((object) => {
      //   var tempinf = (object.Value * 9 / 5) + 32
      //   // console.log(tempinf)
      //   bodyTempHxRy.push(tempinf)
      // })
      // bodyTempHxRy = bodyTempHxRy.slice(r1, r2)
      // this.setState({ bodyTempHxRy })
      // console.log(bodyTempHxRy)

    })

  }

  componentWillUnmount() {
    this.mq2Listen.off();
    this.mq9Listen.off();
    this.mq135Listen.off();
    this.tempListen.off();
    this.humidListen.off();
    this.bodyTempListen.off();
    this.bodyOxListen.off();
    this.dysBPListen.off();
    this.sysBPListen.off();
    this.dysListen.off();
    this.nameListen.off();
    this.roomListen.off();
    clearInterval(this.state.listener);
    clearInterval(this.state.timeLabel)
  }

  timestampLabel() {

    // this.heartRateArray.forEach((object)=>{
    //   this.heartRateArray.push({label:currentTime})
    // })


    // let hearttsdata = heartRateArray[0].y;
    // heartRateArray.push({ x: xValHeartRate, y: heartRateData });
  }



  updateChart() {
    // console.log(Date().toLocaleString().split(' ')[4])
    let heartRateData = heartRateArray[0].y;
    heartRateArray1.push({ x: xValHeartRate, y: heartRateData, label: this.getCurrentTime() });
    if (heartRateArray1.length > 100) {
      heartRateArray1.shift()
    }
    heartRateArray.push({ x: xValHeartRate, y: heartRateData })
    xValHeartRate++;
    if (heartRateArray.length > 1) {
      heartRateArray.shift();
    }
    this?.heartRateChart?.render();
    // this?.bodyTempChart?.render();
    // this?.systolicChart?.render();
    // this?.diastolicChart?.render();
    console.log(heartRateArray1)

    // -----------Blood Oxygen---------------
    let bloodOxData = bloodOxArray[0].y;
    bloodOxArray1.push({ x: xValBloodOX, y: bloodOxData, label: this.getCurrentTime() });
    if (bloodOxArray1.length > 100) {
      bloodOxArray1.shift();
    }
    bloodOxArray.push({ x: xValBloodOX, y: bloodOxData });
    // console.log(bloodOxArray)
    xValBloodOX++
    if (bloodOxArray.length > 1) {
      bloodOxArray.shift();
    }
    this?.bloodOxChart?.render();

    // -----------Systolic---------------

    let systolicData = systolicArray[0].y
    systolicArray1.push({ x: xValSystolic, y: systolicData, label: this.getCurrentTime() })
    if (systolicArray1.length > 100) {
      systolicArray1.shift()
    }
    systolicArray.push({ x: xValSystolic, y: systolicData })

    xValSystolic++
    if (systolicArray.length > 100) {
      systolicArray.shift()
    }
    this?.systolicChart?.render();

    // -----------Diastolic---------------

    let diastolicData = diastolicArray[0].y
    diastolicArray1.push({ x: xValDiastolic, y: diastolicData, label: this.getCurrentTime() })
    if (diastolicArray1.length > 100) {
      diastolicArray1.shift()
    }
    diastolicArray.push({ x: xValDiastolic, y: diastolicData })
    xValDiastolic++
    if (diastolicArray.length > 1) {
      diastolicArray.shift()
    }
    this?.diastolicChart?.render();

    // -----------Body Temp---------------

    // let bodyTempData = bodyTempArray[0].y
    // bodyTempArray1.push({ x: xValBodyTemp, y: bodyTempData, label: this.getCurrentTime() })
    // if (bodyTempArray1.length > 100) {
    //   bodyTempArray1.shift()
    // }
    // bodyTempArray.push({ x: xValBodyTemp, y: bodyTempData })
    // xValBodyTemp++
    // if (bodyTempArray.length > 1) {
    //   bodyTempArray.shift()
    // }
    // ---------------H1R1--------------------------
    if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1') {
      // ---------Body Temp---------------
      let bodyTempH1R1Data = this.state.bodyTempH1R1[0]
      bodyTempH1R1_1.push({ x: xValBodyTempH1R1, y: bodyTempH1R1Data, label: this.getCurrentTime() })
      if (bodyTempH1R1_1.length > 100) {
        bodyTempH1R1_1.shift()
      }
      xValBodyTempH1R1++
      if (this.state.bodyTempH1R1.length > 1) {
        this.setState({ bodyTempH1R1: this.state.bodyTempH1R1.slice(1) })
      }
      this.setState({ bodyTempH1R1: this.state.bodyTempH1R1.concat(bodyTempH1R1Data) })
      console.log(this.state.bodyTempH1R1)
      console.log(bodyTempH1R1_1)
      this?.bodyTempChart?.render();

      // ---------Blood Ox-------------------
      let bloodOxH1R1Data = this.state.bloodOxH1R1[0];
      bloodOxH1R1_1.push({ x: xValBloodOXH1R1, y: bloodOxH1R1Data, label: this.getCurrentTime() });
      if (bloodOxH1R1_1.length > 100) {
        bloodOxH1R1_1.shift();
      }
      xValBloodOXH1R1++
      if (this.state.bloodOxH1R1.length > 1) {
        this.setState({ bloodOxH1R1: this.state.bloodOxH1R1.slice(1) })
      }
      this.setState({ bloodOxH1R1: this.state.bloodOxH1R1.concat(bloodOxH1R1Data) })
      console.log(this.state.bloodOxH1R1)
      console.log(bloodOxH1R1_1)
      this?.bloodOxChart?.render();

      // -------------Diastolic------------
      let diastolicH1R1Data = this.state.diastolicH1R1[0];
      diastolicH1R1_1.push({ x: xValDiastolicH1R1, y: diastolicH1R1Data, label: this.getCurrentTime() })
      if (diastolicH1R1_1.length > 100) {
        diastolicH1R1_1.shift();
      }
      xValDiastolicH1R1++
      if (this.state.diastolicH1R1.length > 1) {
        this.setState({ diastolicH1R1: this.state.diastolicH1R1.slice(1) })
      }
      this.setState({ diastolicH1R1: this.state.diastolicH1R1.concat(diastolicH1R1Data) })
      console.log(this.state.diastolicH1R1)
      console.log(diastolicH1R1_1)
      this?.diastolicChart?.render();

      // --------------Systolic-------------------
      let systolicH1R1Data = this.state.systolicH1R1[0];
      systolicH1R1_1.push({ x: xValSystolicH1R1, y: systolicH1R1Data, label: this.getCurrentTime() })
      if (systolicH1R1_1.length > 100) {
        systolicH1R1_1.shift();
      }
      xValSystolicH1R1++
      if (this.state.systolicH1R1.length > 1) {
        this.setState({ systolicH1R1: this.state.systolicH1R1.slice(1) })
      }
      this.setState({ systolicH1R1: this.state.systolicH1R1.concat(systolicH1R1Data) })
      console.log(this.state.systolicH1R1)
      console.log(systolicH1R1_1)
      this?.systolicChart?.render();


      // --------------Heart Rate-----------------
      let heartRateH1R1Data = this.state.heartRateH1R1[0];
      heartRateH1R1_1.push({ x: xValHeartRateH1R1, y: heartRateH1R1Data, label: this.getCurrentTime() })
      if (heartRateH1R1_1.length > 100) {
        heartRateH1R1_1.shift();
      }
      xValHeartRateH1R1++
      if (this.state.heartRateH1R1.length > 1) {
        this.setState({ heartRateH1R1: this.state.heartRateH1R1.slice(1) })
      }
      this.setState({ heartRateH1R1: this.state.heartRateH1R1.concat(heartRateH1R1Data) })
      console.log(this.state.heartRateH1R1)
      console.log(heartRateH1R1_1)
      this?.systolicChart?.render();

    }



    // ---------------H1R2--------------------------
    else if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2') {
      // ---------Body Temp---------------
      let bodyTempH1R2Data = this.state.bodyTempH1R2[0]
      bodyTempH1R2_1.push({ x: xValBodyTempH1R2, y: bodyTempH1R2Data, label: this.getCurrentTime() })
      if (bodyTempH1R2_1.length > 100) {
        bodyTempH1R2_1.shift()
      }
      xValBodyTempH1R2++
      if (this.state.bodyTempH1R2.length > 1) {
        this.setState({ bodyTempH1R2: this.state.bodyTempH1R2.slice(1) })
      }
      this.setState({ bodyTempH1R2: this.state.bodyTempH1R2.concat(bodyTempH1R2Data) })
      console.log(this.state.bodyTempH1R2)
      console.log(bodyTempH1R2_1)
      this?.bodyTempChart?.render();

      // ---------Blood Ox-------------------
      let bloodOxH1R2Data = this.state.bloodOxH1R2[0];
      bloodOxH1R2_1.push({ x: xValBloodOXH1R2, y: bloodOxH1R2Data, label: this.getCurrentTime() });
      if (bloodOxH1R2_1.length > 100) {
        bloodOxH1R2_1.shift();
      }
      xValBloodOXH1R2++
      if (this.state.bloodOxH1R2.length > 1) {
        this.setState({ bloodOxH1R2: this.state.bloodOxH1R2.slice(1) })
      }
      this.setState({ bloodOxH1R2: this.state.bloodOxH1R2.concat(bloodOxH1R2Data) })
      console.log(this.state.bloodOxH1R2)
      console.log(bloodOxH1R2_1)
      this?.bloodOxChart?.render();

      // -------------Diastolic------------
      let diastolicH1R2Data = this.state.diastolicH1R2[0];
      diastolicH1R2_1.push({ x: xValDiastolicH1R2, y: diastolicH1R2Data, label: this.getCurrentTime() })
      if (diastolicH1R2_1.length > 100) {
        diastolicH1R2_1.shift();
      }
      xValDiastolicH1R2++
      if (this.state.diastolicH1R2.length > 1) {
        this.setState({ diastolicH1R2: this.state.diastolicH1R2.slice(1) })
      }
      this.setState({ diastolicH1R2: this.state.diastolicH1R2.concat(diastolicH1R2Data) })
      console.log(this.state.diastolicH1R2)
      console.log(diastolicH1R2_1)
      this?.diastolicChart?.render();

      // --------------Systolic-------------------
      let systolicH1R2Data = this.state.systolicH1R2[0];
      systolicH1R2_1.push({ x: xValSystolicH1R2, y: systolicH1R2Data, label: this.getCurrentTime() })
      if (systolicH1R2_1.length > 100) {
        systolicH1R2_1.shift();
      }
      xValSystolicH1R2++
      if (this.state.systolicH1R2.length > 1) {
        this.setState({ systolicH1R2: this.state.systolicH1R2.slice(1) })
      }
      this.setState({ systolicH1R2: this.state.systolicH1R2.concat(systolicH1R2Data) })
      console.log(this.state.systolicH1R2)
      console.log(systolicH1R2_1)
      this?.systolicChart?.render();


      // --------------Heart Rate-----------------
      let heartRateH1R2Data = this.state.heartRateH1R2[0];
      heartRateH1R2_1.push({ x: xValHeartRateH1R2, y: heartRateH1R2Data, label: this.getCurrentTime() })
      if (heartRateH1R2_1.length > 100) {
        heartRateH1R2_1.shift();
      }
      xValHeartRateH1R2++
      if (this.state.heartRateH1R2.length > 1) {
        this.setState({ heartRateH1R2: this.state.heartRateH1R2.slice(1) })
      }
      this.setState({ heartRateH1R2: this.state.heartRateH1R2.concat(heartRateH1R2Data) })
      console.log(this.state.heartRateH1R2)
      console.log(heartRateH1R2_1)
      this?.systolicChart?.render();
    }
    // ---------------H1R3--------------------------
    else if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3') {
      // ---------Body Temp---------------
      let bodyTempH1R3Data = this.state.bodyTempH1R3[0]
      bodyTempH1R3_1.push({ x: xValBodyTempH1R3, y: bodyTempH1R3Data, label: this.getCurrentTime() })
      if (bodyTempH1R3_1.length > 100) {
        bodyTempH1R3_1.shift()
      }
      xValBodyTempH1R3++
      if (this.state.bodyTempH1R3.length > 1) {
        this.setState({ bodyTempH1R3: this.state.bodyTempH1R3.slice(1) })
      }
      this.setState({ bodyTempH1R3: this.state.bodyTempH1R3.concat(bodyTempH1R3Data) })
      console.log(this.state.bodyTempH1R3)
      console.log(bodyTempH1R3_1)
      this?.bodyTempChart?.render();

      // ---------Blood Ox-------------------
      let bloodOxH1R3Data = this.state.bloodOxH1R3[0];
      bloodOxH1R3_1.push({ x: xValBloodOXH1R3, y: bloodOxH1R3Data, label: this.getCurrentTime() });
      if (bloodOxH1R3_1.length > 100) {
        bloodOxH1R3_1.shift();
      }
      xValBloodOXH1R3++
      if (this.state.bloodOxH1R3.length > 1) {
        this.setState({ bloodOxH1R3: this.state.bloodOxH1R3.slice(1) })
      }
      this.setState({ bloodOxH1R3: this.state.bloodOxH1R3.concat(bloodOxH1R3Data) })
      console.log(this.state.bloodOxH1R3)
      console.log(bloodOxH1R3_1)
      this?.bloodOxChart?.render();

      // -------------Diastolic------------
      let diastolicH1R3Data = this.state.diastolicH1R3[0];
      diastolicH1R3_1.push({ x: xValDiastolicH1R3, y: diastolicH1R3Data, label: this.getCurrentTime() })
      if (diastolicH1R3_1.length > 100) {
        diastolicH1R3_1.shift();
      }
      xValDiastolicH1R3++
      if (this.state.diastolicH1R3.length > 1) {
        this.setState({ diastolicH1R3: this.state.diastolicH1R3.slice(1) })
      }
      this.setState({ diastolicH1R3: this.state.diastolicH1R3.concat(diastolicH1R3Data) })
      console.log(this.state.diastolicH1R3)
      console.log(diastolicH1R3_1)
      this?.diastolicChart?.render();

      // --------------Systolic-------------------
      let systolicH1R3Data = this.state.systolicH1R3[0];
      systolicH1R3_1.push({ x: xValSystolicH1R3, y: systolicH1R3Data, label: this.getCurrentTime() })
      if (systolicH1R3_1.length > 100) {
        systolicH1R3_1.shift();
      }
      xValSystolicH1R3++
      if (this.state.systolicH1R3.length > 1) {
        this.setState({ systolicH1R3: this.state.systolicH1R3.slice(1) })
      }
      this.setState({ systolicH1R3: this.state.systolicH1R3.concat(systolicH1R3Data) })
      console.log(this.state.systolicH1R3)
      console.log(systolicH1R3_1)
      this?.systolicChart?.render();


      // --------------Heart Rate-----------------
      let heartRateH1R3Data = this.state.heartRateH1R3[0];
      heartRateH1R3_1.push({ x: xValHeartRateH1R3, y: heartRateH1R3Data, label: this.getCurrentTime() })
      if (heartRateH1R3_1.length > 100) {
        heartRateH1R3_1.shift();
      }
      xValHeartRateH1R3++
      if (this.state.heartRateH1R3.length > 1) {
        this.setState({ heartRateH1R3: this.state.heartRateH1R3.slice(1) })
      }
      this.setState({ heartRateH1R3: this.state.heartRateH1R3.concat(heartRateH1R3Data) })
      console.log(this.state.heartRateH1R3)
      console.log(heartRateH1R3_1)
      this?.systolicChart?.render();
    }
    // ---------------H1R4--------------------------
    else if (this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4') {
      // ---------Body Temp---------------
      let bodyTempH1R4Data = this.state.bodyTempH1R4[0]
      bodyTempH1R4_1.push({ x: xValBodyTempH1R4, y: bodyTempH1R4Data, label: this.getCurrentTime() })
      if (bodyTempH1R4_1.length > 100) {
        bodyTempH1R4_1.shift()
      }
      xValBodyTempH1R4++
      if (this.state.bodyTempH1R4.length > 1) {
        this.setState({ bodyTempH1R4: this.state.bodyTempH1R4.slice(1) })
      }
      this.setState({ bodyTempH1R4: this.state.bodyTempH1R4.concat(bodyTempH1R4Data) })
      console.log(this.state.bodyTempH1R4)
      console.log(bodyTempH1R4_1)
      this?.bodyTempChart?.render();

      // ---------Blood Ox-------------------
      let bloodOxH1R4Data = this.state.bloodOxH1R4[0];
      bloodOxH1R4_1.push({ x: xValBloodOXH1R4, y: bloodOxH1R4Data, label: this.getCurrentTime() });
      if (bloodOxH1R4_1.length > 100) {
        bloodOxH1R4_1.shift();
      }
      xValBloodOXH1R4++
      if (this.state.bloodOxH1R4.length > 1) {
        this.setState({ bloodOxH1R4: this.state.bloodOxH1R4.slice(1) })
      }
      this.setState({ bloodOxH1R4: this.state.bloodOxH1R4.concat(bloodOxH1R4Data) })
      console.log(this.state.bloodOxH1R4)
      console.log(bloodOxH1R4_1)
      this?.bloodOxChart?.render();

      // -------------Diastolic------------
      let diastolicH1R4Data = this.state.diastolicH1R4[0];
      diastolicH1R4_1.push({ x: xValDiastolicH1R4, y: diastolicH1R4Data, label: this.getCurrentTime() })
      if (diastolicH1R4_1.length > 100) {
        diastolicH1R4_1.shift();
      }
      xValDiastolicH1R4++
      if (this.state.diastolicH1R4.length > 1) {
        this.setState({ diastolicH1R4: this.state.diastolicH1R4.slice(1) })
      }
      this.setState({ diastolicH1R4: this.state.diastolicH1R4.concat(diastolicH1R4Data) })
      console.log(this.state.diastolicH1R4)
      console.log(diastolicH1R4_1)
      this?.diastolicChart?.render();

      // --------------Systolic-------------------
      let systolicH1R4Data = this.state.systolicH1R4[0];
      systolicH1R4_1.push({ x: xValSystolicH1R4, y: systolicH1R4Data, label: this.getCurrentTime() })
      if (systolicH1R4_1.length > 100) {
        systolicH1R4_1.shift();
      }
      xValSystolicH1R4++
      if (this.state.systolicH1R4.length > 1) {
        this.setState({ systolicH1R4: this.state.systolicH1R4.slice(1) })
      }
      this.setState({ systolicH1R4: this.state.systolicH1R4.concat(systolicH1R4Data) })
      console.log(this.state.systolicH1R4)
      console.log(systolicH1R4_1)
      this?.systolicChart?.render();


      // --------------Heart Rate-----------------
      let heartRateH1R4Data = this.state.heartRateH1R4[0];
      heartRateH1R4_1.push({ x: xValHeartRateH1R4, y: heartRateH1R4Data, label: this.getCurrentTime() })
      if (heartRateH1R4_1.length > 100) {
        heartRateH1R4_1.shift();
      }
      xValHeartRateH1R4++
      if (this.state.heartRateH1R4.length > 1) {
        this.setState({ heartRateH1R4: this.state.heartRateH1R4.slice(1) })
      }
      this.setState({ heartRateH1R4: this.state.heartRateH1R4.concat(heartRateH1R4Data) })
      console.log(this.state.heartRateH1R4)
      console.log(heartRateH1R4_1)
      this?.systolicChart?.render();
    }

    // --------------- H2R1--------------------------
    else if (this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1') {
      // ---------Body Temp---------------
      let bodyTempH2R1Data = this.state.bodyTempH2R1[0]
      bodyTempH2R1_1.push({ x: xValBodyTempH2R1, y: bodyTempH2R1Data, label: this.getCurrentTime() })
      if (bodyTempH2R1_1.length > 100) {
        bodyTempH2R1_1.shift()
      }
      xValBodyTempH2R1++
      if (this.state.bodyTempH2R1.length > 1) {
        this.setState({ bodyTempH2R1: this.state.bodyTempH2R1.slice(1) })
      }
      this.setState({ bodyTempH2R1: this.state.bodyTempH2R1.concat(bodyTempH2R1Data) })
      console.log(this.state.bodyTempH2R1)
      console.log(bodyTempH2R1_1)
      this?.bodyTempChart?.render();

      // ---------Blood Ox-------------------
      let bloodOxH2R1Data = this.state.bloodOxH2R1[0];
      bloodOxH2R1_1.push({ x: xValBloodOXH2R1, y: bloodOxH2R1Data, label: this.getCurrentTime() });
      if (bloodOxH2R1_1.length > 100) {
        bloodOxH2R1_1.shift();
      }
      xValBloodOXH2R1++
      if (this.state.bloodOxH2R1.length > 1) {
        this.setState({ bloodOxH2R1: this.state.bloodOxH2R1.slice(1) })
      }
      this.setState({ bloodOxH2R1: this.state.bloodOxH2R1.concat(bloodOxH2R1Data) })
      console.log(this.state.bloodOxH2R1)
      console.log(bloodOxH2R1_1)
      this?.bloodOxChart?.render();

      // -------------Diastolic------------
      let diastolicH2R1Data = this.state.diastolicH2R1[0];
      diastolicH2R1_1.push({ x: xValDiastolicH2R1, y: diastolicH2R1Data, label: this.getCurrentTime() })
      if (diastolicH2R1_1.length > 100) {
        diastolicH2R1_1.shift();
      }
      xValDiastolicH2R1++
      if (this.state.diastolicH2R1.length > 1) {
        this.setState({ diastolicH2R1: this.state.diastolicH2R1.slice(1) })
      }
      this.setState({ diastolicH2R1: this.state.diastolicH2R1.concat(diastolicH2R1Data) })
      console.log(this.state.diastolicH2R1)
      console.log(diastolicH2R1_1)
      this?.diastolicChart?.render();

      // --------------Systolic-------------------
      let systolicH2R1Data = this.state.systolicH2R1[0];
      systolicH2R1_1.push({ x: xValSystolicH2R1, y: systolicH2R1Data, label: this.getCurrentTime() })
      if (systolicH2R1_1.length > 100) {
        systolicH2R1_1.shift();
      }
      xValSystolicH2R1++
      if (this.state.systolicH2R1.length > 1) {
        this.setState({ systolicH2R1: this.state.systolicH2R1.slice(1) })
      }
      this.setState({ systolicH2R1: this.state.systolicH2R1.concat(systolicH2R1Data) })
      console.log(this.state.systolicH2R1)
      console.log(systolicH2R1_1)
      this?.systolicChart?.render();


      // --------------Heart Rate-----------------
      let heartRateH2R1Data = this.state.heartRateH2R1[0];
      heartRateH2R1_1.push({ x: xValHeartRateH2R1, y: heartRateH2R1Data, label: this.getCurrentTime() })
      if (heartRateH2R1_1.length > 100) {
        heartRateH2R1_1.shift();
      }
      xValHeartRateH2R1++
      if (this.state.heartRateH2R1.length > 1) {
        this.setState({ heartRateH2R1: this.state.heartRateH2R1.slice(1) })
      }
      this.setState({ heartRateH2R1: this.state.heartRateH2R1.concat(heartRateH2R1Data) })
      console.log(this.state.heartRateH2R1)
      console.log(heartRateH2R1_1)
      this?.systolicChart?.render();
    }
    // ---------------H2R2--------------------------
    else if (this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2') {
      // ---------Body Temp---------------
      let bodyTempH2R2Data = this.state.bodyTempH2R2[0]
      bodyTempH2R2_1.push({ x: xValBodyTempH2R2, y: bodyTempH2R2Data, label: this.getCurrentTime() })
      if (bodyTempH2R2_1.length > 100) {
        bodyTempH2R2_1.shift()
      }
      xValBodyTempH2R2++
      if (this.state.bodyTempH2R2.length > 1) {
        this.setState({ bodyTempH2R2: this.state.bodyTempH2R2.slice(1) })
      }
      this.setState({ bodyTempH2R2: this.state.bodyTempH2R2.concat(bodyTempH2R2Data) })
      console.log(this.state.bodyTempH2R2)
      console.log(bodyTempH2R2_1)
      this?.bodyTempChart?.render();

      // ---------Blood Ox-------------------
      let bloodOxH2R2Data = this.state.bloodOxH2R2[0];
      bloodOxH2R2_1.push({ x: xValBloodOXH2R2, y: bloodOxH2R2Data, label: this.getCurrentTime() });
      if (bloodOxH2R2_1.length > 100) {
        bloodOxH2R2_1.shift();
      }
      xValBloodOXH2R2++
      if (this.state.bloodOxH2R2.length > 1) {
        this.setState({ bloodOxH2R2: this.state.bloodOxH2R2.slice(1) })
      }
      this.setState({ bloodOxH2R2: this.state.bloodOxH2R2.concat(bloodOxH2R2Data) })
      console.log(this.state.bloodOxH2R2)
      console.log(bloodOxH2R2_1)
      this?.bloodOxChart?.render();

      // -------------Diastolic------------
      let diastolicH2R2Data = this.state.diastolicH2R2[0];
      diastolicH2R2_1.push({ x: xValDiastolicH2R2, y: diastolicH2R2Data, label: this.getCurrentTime() })
      if (diastolicH2R2_1.length > 100) {
        diastolicH2R2_1.shift();
      }
      xValDiastolicH2R2++
      if (this.state.diastolicH2R2.length > 1) {
        this.setState({ diastolicH2R2: this.state.diastolicH2R2.slice(1) })
      }
      this.setState({ diastolicH2R2: this.state.diastolicH2R2.concat(diastolicH2R2Data) })
      console.log(this.state.diastolicH2R2)
      console.log(diastolicH2R2_1)
      this?.diastolicChart?.render();

      // --------------Systolic-------------------
      let systolicH2R2Data = this.state.systolicH2R2[0];
      systolicH2R2_1.push({ x: xValSystolicH2R2, y: systolicH2R2Data, label: this.getCurrentTime() })
      if (systolicH2R2_1.length > 100) {
        systolicH2R2_1.shift();
      }
      xValSystolicH2R2++
      if (this.state.systolicH2R2.length > 1) {
        this.setState({ systolicH2R2: this.state.systolicH2R2.slice(1) })
      }
      this.setState({ systolicH2R2: this.state.systolicH2R2.concat(systolicH2R2Data) })
      console.log(this.state.systolicH2R2)
      console.log(systolicH2R2_1)
      this?.systolicChart?.render();


      // --------------Heart Rate-----------------
      let heartRateH2R2Data = this.state.heartRateH2R2[0];
      heartRateH2R2_1.push({ x: xValHeartRateH2R2, y: heartRateH2R2Data, label: this.getCurrentTime() })
      if (heartRateH2R2_1.length > 100) {
        heartRateH2R2_1.shift();
      }
      xValHeartRateH2R2++
      if (this.state.heartRateH2R2.length > 1) {
        this.setState({ heartRateH2R2: this.state.heartRateH2R2.slice(1) })
      }
      this.setState({ heartRateH2R2: this.state.heartRateH2R2.concat(heartRateH2R2Data) })
      console.log(this.state.heartRateH2R2)
      console.log(heartRateH2R2_1)
      this?.systolicChart?.render();
    }

    // if (this.state.bodyTempHxRy != null) {
    //   let bodyTempH1R2Data = this.state.bodyTempHxRy[0]
    //   bodyTempHxRy_1.push({ x: xValBodyTemp, y: bodyTempH1R2Data, label: this.getCurrentTime() })
    //   if (bodyTempHxRy_1.length > 100) {
    //     bodyTempHxRy_1.shift()
    //   }
    //   xValBodyTemp++
    //   if (this.state.bodyTempHxRy.length > 1) {
    //     this.setState({ bodyTempHxRy: this.state.bodyTempHxRy.slice(1) })
    //   }
    //   this.setState({ bodyTempHxRy: this.state.bodyTempHxRy.concat(bodyTempH1R2Data) })
    //   console.log(this.state.bodyTempHxRy)
    //   console.log(bodyTempHxRy_1)
    //   this?.bodyTempChart?.render();
    // }


    // -----------Mq9---------------

    let mq9Data = mq9Array[0].y
    mq9Array1.push({ x: xValMq9Data, y: mq9Data, label: this.getCurrentTime() })
    if (mq9Array1.length > 100) {
      mq9Array1.shift()
    }
    mq9Array.push({ x: xValMq9Data, y: mq9Data })
    xValMq9Data++
    if (mq9Array.length > 1) {
      mq9Array.shift()
    }
    this?.mq9Chart?.render();

    // -----------Mq135---------------

    let mq135Data = mq135Array[0].y
    mq135Array1.push({ x: xValMq135Data, y: mq135Data, label: this.getCurrentTime() })
    if (mq135Array1.length > 100) {
      mq135Array1.shift()
    }
    mq135Array.push({ x: xValMq135Data, y: mq135Data })
    xValMq135Data++
    if (mq135Array.length > 1) {
      mq135Array.shift()
    }
    this?.mq135Chart?.render();

    // -----------Humid---------------

    let humidiData = humidArray[0].y
    humidArray1.push({ x: humidityData, y: humidiData, label: this.getCurrentTime() })
    if (humidArray1.length > 100) {
      humidArray1.shift()
    }
    humidArray.push({ x: humidityData, y: humidiData })
    humidityData++
    if (humidArray.length > 1) {
      humidArray.shift()
    }
    this?.humidChart?.render();

    // -----------Humid---------------

    let roomtempData = roomTempArray[0].y
    roomTempArray1.push({ x: roomTempData, y: roomtempData, label: this.getCurrentTime() })
    if (roomTempArray1.length > 100) {
      roomTempArray1.shift()
    }
    roomTempArray.push({ x: roomTempData, y: roomtempData })
    roomTempData++
    if (roomTempArray.length > 1) {
      roomTempArray.shift()
    }
    this?.roomTempChart?.render();
    // -----------Mq2---------------
    let mq2data = mq2Array[0].y
    mq2Array1.push({ x: xValMq2Data, y: mq2data, label: this.getCurrentTime() });
    if (mq2Array1.length > 100) {
      mq2Array1.shift();
    }
    mq2Array.push({ x: xValMq2Data, y: mq2data });
    xValMq2Data++;
    if (mq2Array.length > 1) {
      mq2Array.shift();
    }
    this?.mq2ArrayChart?.render();


  }

  render() {

    const { match, location, history } = this.props

    const heartRateOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Heart Rate'
      },
      data: [{
        type: "line",
        dataPoints: this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1' ? heartRateH1R1_1
          : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2' ? heartRateH1R2_1
            : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3' ? heartRateH1R3_1
              : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4' ? heartRateH1R4_1
                : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1' ? heartRateH2R1_1
                  : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2' ? heartRateH2R2_1
                    : heartRateArray1
      }]
    };

    const mq2Options = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'MQ2'
      },
      data: [{
        type: "line",
        dataPoints: mq2Array1,
      }]
    };

    const bloodOxOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Blood Ox'
      },
      data: [{
        type: "line",
        dataPoints: this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1' ? bloodOxH1R1_1
          : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2' ? bloodOxH1R2_1
            : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3' ? bloodOxH1R3_1
              : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4' ? bloodOxH1R4_1
                : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1' ? bloodOxH2R1_1
                  : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2' ? bloodOxH2R2_1
                    : bloodOxArray1
      }]
    };

    const systolicOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Systolic'
      },
      data: [{
        type: "line",
        dataPoints: this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1' ? systolicH1R1_1
          : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2' ? systolicH1R2_1
            : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3' ? systolicH1R3_1
              : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4' ? systolicH1R4_1
                : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1' ? systolicH2R1_1
                  : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2' ? systolicH2R2_1
                    : systolicArray1
      }]
    };

    const diastolicOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Diastolic'
      },
      data: [{
        type: "line",
        dataPoints: this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1' ? diastolicH1R1_1
          : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2' ? diastolicH1R2_1
            : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3' ? diastolicH1R3_1
              : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4' ? diastolicH1R4_1
                : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1' ? diastolicH2R1_1
                  : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2' ? diastolicH2R2_1
                    : diastolicArray1
      }]
    };

    const bodyTempOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Body Temp'
      },
      data: [{
        type: "line",
        dataPoints: this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-1' ? bodyTempH1R1_1
          : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-2' ? bodyTempH1R2_1
            : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-3' ? bodyTempH1R3_1
              : this.props.match.params.hospitalId == 'hospital-1' && this.props.match.params.roomId == 'room-4' ? bodyTempH1R4_1
                : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-1' ? bodyTempH2R1_1
                  : this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-2' ? bodyTempH2R2_1
                    : bodyTempArray1
      }]
    };
    // ------------MQ9------------
    const mq9Options = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'MQ9'
      },
      data: [{
        type: "line",
        dataPoints: mq9Array1,
      }]
    };

    // ------------MQ135------------
    const mq135Options = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'MQ135'
      },
      data: [{
        type: "line",
        dataPoints: mq135Array1,
      }]
    };

    // ------------Humidity------------
    const humidOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Humidity'
      },
      data: [{
        type: "line",
        dataPoints: humidArray1,
      }]
    };

    // ------------Room Temp------------
    const roomTempOptions = {

      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Room Temp'
      },
      data: [{
        type: "line",
        dataPoints: roomTempArray1,
      }]
    };


    //  ------------- Mq2 RTDB ----------------
    const mq2RtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'MQ2'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsMq2,
      }]
    }
    //  ------------- Mq9 RTDB ----------------
    const mq9RtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'MQ9'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsMq9,
      }]
    }
    //  ------------- Mq135 RTDB ----------------
    const mq135RtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Mq135'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsMq135,
      }]
    }
    //  ------------- Room Temp RTDB ----------------
    const roomTempRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Room Temp'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsRoomTemp,
      }]
    }
    //  ------------- Humidity RTDB ----------------
    const humidRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Humidity'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsHumid,
      }]
    }
    //  ------------- HeartRate RTDB ----------------
    const heartRateRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Heart Rate'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsHeartRate,
      }]
    }
    //  ------------- Diastolic RTDB ----------------
    const diastolicRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Diastolic'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsBloodPressureDiastolic,
      }]
    }
    //  ------------- Systolic RTDB ----------------
    const systolicRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Systolic'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsBloodPressureSystolic,
      }]
    }
    //  ------------- BodyTemp RTDB ----------------
    const bodyTempRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Body Temp'
      },
      data: [{
        type: "line",
        dataPoints: bodyTempH1R2_1,
      }]
    }
    //  ------------- Blood Ox RTDB ----------------
    const bloodOxRtdbOptions = {
      height: 168,
      axisX: {

        title: 'Time'
      },
      axisY: {
        title: 'Blood Ox'
      },
      data: [{
        type: "line",
        dataPoints: this.state.plotPointsBloodOxygen,
      }]
    }

    const { classes, theme } = this.props;
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    // const fixedHeightPaper = clsx(cqlasses.paper, classes.fixedHeight);  
    return (

      <div>
        <div className={classes.root}>

          <main className={classes.content}>

            {/* ------------------Emotional Status---------------- */}
            <Container className="emotionpara">
              <hr></hr>
              
              
              <h4 className="heading-charts">Emotional Status</h4>
              <hr />
              

              <div class="card text-center emotion">
                {/* <div class="card-header ">Emotion</div> */}
                <Grid container spacing={3}>
                <Grid item xs={3}>
                <Paper className={classes.paper}>
                  
                  <div className = "emotionhead">
                    <img src={defaultProfile} alt="defaultProfile" />
                  </div>
                </Paper>
              </Grid>
              <Grid item xs={9}>
                <Paper className={classes.paper}>
                <div className="emotion-top"></div>
                <div class="emotionhead" id="patientName">Name: </div>  
                <div class="emotionhead" id="Emotion">Emotion: </div>
                <div class="emotionhead" id="Timestamp">Timestamp:</div>
                <div class="emotionhead" id="name"> </div>
                </Paper>
              </Grid>
              </Grid>

                
                {/* <div class="card-footer" id="Timestamp">Timestamp:</div> */}
              </div>
              
            </Container>

            {/* ---------------Blood Pressure Systolic Component---------------- */}
            <br></br>
            <h4 className="heading-charts">Body Parameters</h4>
            <hr></hr>
            <Card>
              <Card.Header>Blood Pressure Systolic</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? this.state.bloodPressureSystolicTimestamp[this.state.bloodPressureSystolicTimestamp.length - 1] :
                          Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? systolicRtdbOptions : systolicOptions} onRef={(ref) => (this.systolicChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading-charts">Emotional Status</h4>
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugeSys"
                              nrOfLevels={420}
                              hideText={true}
                              arcsLength={[0.3, 0.5, 0.2]}
                              colors={['#5BE12C', '#F5CD19', '#EA4228']}
                              percent={0.37}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="bodySysBP"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                In Millimeters of Mercury (mm Hg)
              </Card.Footer>
            </Card>

            {/* ---------------Blood Pressure Diastolic Component---------------- */}
            <br></br>


            <Card>
              <Card.Header>Blood Pressure Diastolic</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? this.state.bloodPressureDiastolicTimestamp[this.state.bloodPressureDiastolicTimestamp.length - 1] :
                          Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? diastolicRtdbOptions : diastolicOptions} onRef={(ref) => (this.diastolicChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading-charts">Emotional Status</h4>
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugeDys"
                              nrOfLevels={420}
                              arcsLength={[0.3, 0.5, 0.2]}
                              hideText={true}
                              colors={['#5BE12C', '#F5CD19', '#EA4228']}
                              percent={0.37}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="bodyDysBP"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                In Millimeters of Mercury (mm Hg)
              </Card.Footer>
            </Card>

            {/* ---------------Body Temperature Component---------------- */}
            <br></br>

            <Card>
              <Card.Header>Body Temperature</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? this.state.bodyTempTimestamp[this.state.bodyTempTimestamp.length - 1] :
                          Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? bodyTempRtdbOptions : bodyTempOptions} onRef={(ref) => (this.bodyTempChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading-charts">Emotional Status</h4>
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gauge-bodytemp"
                              nrOfLevels={5}
                              arcsLength={[0.46, 0.09, 0.08, 0.09, 0.46]}
                              hideText={true}
                              colors={['#EA4228', '#F5CD19', '#5BE12C', '#F5CD19', '#EA4228']}
                              percent={this.state.bodyTempValue1}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="bodyTempValue"></div>




                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                In Degree Fahrenheit
              </Card.Footer>
            </Card>

            {/* ---------------Blood Oxygen Saturation Component---------------- */}
            <br></br>

            <Card>
              <Card.Header>Blood Oxygen Saturation</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? this.state.bloodOxygenTimestamp[this.state.bloodOxygenTimestamp.length - 1] :
                          Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? bloodOxRtdbOptions : bloodOxOptions} onRef={(ref) => (this.bloodOxChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading-charts">Emotional Status</h4>
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gauge-bloodox"
                              nrOfLevels={420}
                              arcsLength={[0.75, 0.125, 0.125]}
                              hideText={true}
                              colors={['#EA4228', '#F5CD19', '#5BE12C']}
                              percent={this.state.bodyOxValue1}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="bodyOxValue"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                In percentage
              </Card.Footer>
            </Card>

            {/* ---------------Heart Rate Component---------------- */}
            <br></br>

            <Card>
              <Card.Header>Heart Rate</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? this.state.heartRateTimestamp[this.state.heartRateTimestamp.length - 1] :
                          Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? heartRateRtdbOptions : heartRateOptions} onRef={(ref) => (this.heartRateChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading-charts">Emotional Status</h4>
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gauge-heartrate"
                              nrOfLevels={5}
                              arcsLength={[0.1, 0.08, 0.36, 0.26, 0.2]}
                              hideText={true}
                              colors={['#EA4228', '#F5CD19', '#5BE12C', '#F5CD19', '#EA4228',]}
                              percent={this.state.bodyHeartRateValue1}
                              arcPadding={0.02}
                              // animate={false}
                              textColor="#000000"
                            />
                            <div id="bodyHeartRateValue"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                In Beats per minute (bpm)
              </Card.Footer>
            </Card>



            <br></br>
            {/* <Container className="bodypara">
              <h4 className="heading-charts">Body Parameters</h4>
              <hr />


              <div className="row card-deck  roomsecondrow">
                <div className="card text-center">
                  <div class="card-header">Blood Pressure Systolic Value</div>
                  <div class="card-body">


                    <GaugeChart id="gaugeSys"
                      nrOfLevels={420}
                      hideText={true}
                      arcsLength={[0.3, 0.5, 0.2]}
                      colors={['#5BE12C', '#F5CD19', '#EA4228']}
                      percent={0.37}
                      arcPadding={0.02}
                      textColor="#000000"
                    />
                    <div id="bodySysBP"></div>
                  </div>
                  <div class="card-footer">In Millimeters of Mercury (mm Hg)</div>
                </div>

                <div className="card text-center">
                  <div class="card-header">Blood Pressure Diastolic Value</div>
                  <div class="card-body">


                    <GaugeChart id="gaugeDys"
                      nrOfLevels={420}
                      arcsLength={[0.3, 0.5, 0.2]}
                      hideText={true}
                      colors={['#5BE12C', '#F5CD19', '#EA4228']}
                      percent={0.37}
                      arcPadding={0.02}
                      textColor="#000000"
                    />
                    <div id="bodyDysBP"></div>
                  </div>
                  <div class="card-footer">In Millimeters of Mercury (mm Hg)</div>
                </div>

              </div>





              <div class="card-deck">
                <div class="card text-center">
                  <div class="card-header">Body Temperature</div>
                  <div class="card-body">
                    <GaugeChart id="gauge-bodytemp"
                      nrOfLevels={5}
                      arcsLength={[0.2, 0.1, 0.4, 0.1, 0.2]}
                      hideText={true}
                      colors={['#EA4228', '#F5CD19', '#5BE12C', '#F5CD19', '#EA4228']}
                      percent={this.state.bodyTempValue1}
                      arcPadding={0.02}
                      textColor="#000000"
                    />
                    <div id="bodyTempValue"></div>
                  </div>
                  <div class="card-footer">In Degree Fahrenheit</div>
                </div>


                <div class="card text-center">
                  <div class="card-header">Blood Oxygen Saturation</div>
                  <div class="card-body">
                    <GaugeChart id="gauge-bloodox"
                      nrOfLevels={420}
                      arcsLength={[0.75, 0.125, 0.125]}
                      hideText={true}
                      colors={['#EA4228', '#F5CD19', '#5BE12C']}
                      percent={this.state.bodyOxValue1}
                      arcPadding={0.02}
                      textColor="#000000"
                    />
                    <div id="bodyOxValue"></div>
                  </div>
                  <div class="card-footer">In percentage</div>
                </div>

                <div class="card text-center">
                  <div class="card-header">Heart Rate</div>
                  <div class="card-body">
                    <GaugeChart id="gauge-heartrate"
                      nrOfLevels={5}
                      arcsLength={[0.1, 0.08, 0.36, 0.26, 0.2]}
                      hideText={true}
                      colors={['#EA4228', '#F5CD19', '#5BE12C', '#F5CD19', '#EA4228',]}
                      percent={this.state.bodyHeartRateValue1}
                      arcPadding={0.02}
                      // animate={false}
                      textColor="#000000"
                    />
                    <div id="bodyHeartRateValue"></div>
                  </div>
                  <div class="card-footer">In Beats per minute (bpm)</div>
                </div>
              </div>





            </Container> */}





            {/* ---------------MQ2 Component---------------- */}

            <br></br>
            <h4 className="heading-charts">Room Parameters</h4>
            <hr></hr>
            <Card>
              <Card.Header>MQ2</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? mq2RtdbOptions : mq2Options} onRef={(ref) => (this.mq2ArrayChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading-charts">Emotional Status</h4>
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugemq2 style={chartStyle}"
                              nrOfLevels={2}
                              hideText={true}
                              arcsLength={[0.015, 0.985]}
                              colors={['#5BE12C', '#F5CD19']}
                              percent={this.state.mq2Value1}
                              arcPadding={0.02}
                              textColor="#000000"
                            />


                            <div id="mq2Value"></div>


                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                Sensitive to Methane, Butane, LPG, Smoke
              </Card.Footer>
            </Card>

            {/* -----------------MQ9 Component---------------------- */}

            <br></br>

            <Card>
              <Card.Header>MQ9</Card.Header>
              <Card.Body>
                {/* <Card.Text>
           Sensitive to Methane, Butane, LPG, Smoke
           </Card.Text> */}
                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? mq9RtdbOptions : mq9Options} onRef={(ref) => (this.mq9Chart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading">Emotional Status</h4>
                <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugemq9"
                              nrOfLevels={3}
                              hideText={true}
                              arcsLength={[0.06, 0.34, 0.6]}
                              colors={['#5BE12C', '#F5CD19', '#EA4228']}
                              percent={this.state.mq9Value1}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="mq9Value"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                Sensitive to Carbon Monoxide, flammable gasses
              </Card.Footer>
            </Card>


            {/* -----------------MQ135 Component---------------------- */}

            <br></br>

            <Card>
              <Card.Header>MQ135</Card.Header>
              <Card.Body>

                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? mq135RtdbOptions : mq135Options} onRef={(ref) => (this.mq135Chart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading">Emotional Status</h4>
    <hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugemq135"
                              // nrOfLevels={1023}
                              hideText={true}
                              arcsLength={[0.46, 0.32, 0.22]}
                              colors={['#5BE12C', '#F5CD19', '#EA4228']}
                              percent={this.state.mq135Value1}
                              animate={false}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="mq135Value"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                Sensitive to NH3, NOx, Alcohol, Benzene, CO2
              </Card.Footer>
            </Card>


            {/* -----------------Room Temperature Component---------------------- */}

            <br></br>

            <Card>
              <Card.Header>Room Temperature</Card.Header>
              <Card.Body>

                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? roomTempRtdbOptions : roomTempOptions} onRef={(ref) => (this.roomTempChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading">Emotional Status</h4>
<hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugetemp"
                              nrOfLevels={3}
                              hideText={true}
                              arcsLength={[0.5, 0.17, 0.33]}
                              colors={['#5BE12C', '#F5CD19', '#EA4228']}
                              percent={this.state.tempValue1}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="tempValue"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                Sensitive to Temperature
              </Card.Footer>
            </Card>


            {/* -----------------Humidity Component---------------------- */}

            <br></br>

            <Card>
              <Card.Header>Humidity</Card.Header>
              <Card.Body>

                <Grid container spacing={0}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={8}>
                    <Paper className={fixedHeightPaper}>
                      <React.Fragment>

                        <Title>{Date().toLocaleString().split(' ')[0] + ', ' + Date().toLocaleString().split(' ')[1] + ' ' + Date().toLocaleString().split(' ')[2] + " " + Date().toLocaleString().split(' ')[3]}</Title>

                        <CanvasJSChart options={this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-3'
                          || this.props.match.params.hospitalId == 'hospital-2' && this.props.match.params.roomId == 'room-4' ? humidRtdbOptions : humidOptions} onRef={(ref) => (this.humidChart = ref)} />
                      </React.Fragment>




                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper className={fixedHeightPaper}>
                      {/* <Deposits /> */}
                      {/* <h4 className="heading">Emotional Status</h4>
<hr></hr> */}


                      {/* <div class=" text-center"> */}
                      <div className="">
                        <div className=" text-center">

                          <div className="">
                            {/* <canvas id="mq2" className="card-img-top"></canvas> */}
                            <GaugeChart id="gaugehumid"
                              nrOfLevels={420}
                              hideText={true}
                              animate={false}
                              arcsLength={[0.1, 0.2, 0.1, 0.2, 0.3]}
                              colors={['#EA4228', '#F5CD19', '#5BE12C', '#F5CD19', '#EA4228']}
                              percent={this.state.humidValue1}
                              arcPadding={0.02}
                              textColor="#000000"
                            />
                            <div id="humidValue"></div>





                          </div>

                        </div>



                      </div>




                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      {/* <Orders /> */}
                    </Paper>
                  </Grid>
                </Grid>

              </Card.Body>

              <Card.Footer>
                Sensitive to Humidity
              </Card.Footer>
            </Card>


            <Container className='ECGgraph'>
              <hr></hr>
              <div class="card text-center graph">
                <ECG />
              </div>
            </Container>



          </main>
        </div>


      </div>
    )
  }
}

export default withStyles(useStyles, { withTheme: true })(ChartsClass);